<template>
    <div class="container">
        <nav class="add-navigation">
            <div @click="$router.push({name: 'system-admin-dids'})"
                 class="back-link">
                <svg class="icon"
                     width="30px"
                     height="30px"
                     viewBox="0 0 30 30"
                     version="1.1">
                    <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                          id="path-1">
                    </path>
                </svg>
                <p>Back to DIDs</p>
            </div>
            <div class="buttons-wrapper">
                <div @click="$router.push({name: 'company-admin-dids'})"
                     class="secondary-button">
                    <secondary-button>Cancel</secondary-button>
                </div>
                <div class="primary-button">
                    <primary-button @click.native="addcallflow">Create</primary-button>
                </div>
            </div>
        </nav>
        <div class="add-container">
            <span class="container-title">Create Callflow</span>
            <div class="col-wrapper">
                <div class="col">
                    <primary-input type="text"
                                   name="callflow name"
                                   class="field"
                                   v-model="callflow.call_workflow_name"
                                   v-validate="'required'"
                                   :class="{'input': true, 'is-danger': errors.has('callflow name')}"
                                   placeholder="Enter campaign name"/>
                    <div class="help is-danger"
                         v-if="errors.has('callflow name')">
                        {{ errors.first('callflow name') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="callflow-container">
            <div class="cycle-wrapper">
                <div class="cycle-home">
                    <svg class="svg-home"
                         width="30px"
                         height="30px"
                         viewBox="0 0 30 30"
                         version="1.1">
                        <path d="M24.7133515,13.5075766 L15.4490463,5.20674095 C15.1919891,4.97649025 14.8079564,4.97649025 14.5509537,5.20674095 L5.2866485,13.5075766 C5.00376022,13.7610585 4.97542234,14.2010585 5.22337875,14.4903621 C5.47133515,14.7794986 5.90179837,14.8085237 6.18468665,14.5549861 L6.90201635,13.912312 L6.90201635,24.2696379 C6.90201635,24.6542061 7.20697548,24.9660167 7.58321526,24.9660167 L12.7457766,24.9660167 L17.2542234,24.9660167 L22.4167302,24.9660167 C22.79297,24.9660167 23.0979292,24.6542061 23.0979292,24.2696379 L23.0979292,13.9123677 L23.8152589,14.5550975 C23.9445777,14.6708635 24.1046866,14.7277994 24.2639782,14.7277994 C24.453406,14.7277994 24.6418529,14.6475209 24.7765123,14.4904178 C25.0246322,14.2010585 24.9962943,13.7611142 24.7133515,13.5075766 Z M13.4269755,23.5733148 L13.4269755,17.8366574 L16.57297,17.8366574 L16.57297,23.5733148 L13.4269755,23.5733148 Z M21.7356403,12.6969916 L21.7356403,23.5732591 L17.9355313,23.5732591 L17.9355313,17.1402786 C17.9355313,16.7557103 17.6304632,16.4438997 17.2543324,16.4438997 L12.7458856,16.4438997 C12.3697003,16.4438997 12.0646866,16.7557103 12.0646866,17.1402786 L12.0646866,23.5733148 L8.26446866,23.5733148 L8.26446866,12.6969916 C8.26446866,12.6952089 8.26425068,12.6935376 8.26425068,12.6918106 L15,6.65643454 L21.7358583,12.6917549 C21.7359128,12.6935933 21.7356403,12.6952089 21.7356403,12.6969916 Z M13.4741144,11.5592201 C13.4741144,11.943844 13.7790736,12.2555989 14.1553134,12.2555989 L15.8446866,12.2555989 C16.2208719,12.2555989 16.5258856,11.943844 16.5258856,11.5592201 C16.5258856,11.1745961 16.2208719,10.8628412 15.8446866,10.8628412 L14.1553134,10.8628412 C13.7791281,10.8628412 13.4741144,11.1745961 13.4741144,11.5592201 Z"
                              id="path-1">
                        </path>
                    </svg>
                </div>
                <p class="header">Start Call Flow</p>
                <!-- <div class="vertical-line"></div>
                <div class="cycle-plass">
                    <svg class="svg"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1">
                        <path d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                            id="path-1">
                        </path>
                    </svg>
                </div> -->
            </div>
            <div class="start-content">
                <div class="vertical-line"></div>
                <div class="line">
                    <svg class="svg-microphone" viewBox="0 0 32 50" version="1.1" id="Capa_1"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g transform="scale(0.8)">
                            <path d="M44,28c-0.552,0-1,0.447-1,1v6c0,7.72-6.28,14-14,14s-14-6.28-14-14v-6c0-0.553-0.448-1-1-1s-1,0.447-1,1v6c0,8.485,6.644,15.429,15,15.949V56h-5c-0.552,0-1,0.447-1,1s0.448,1,1,1h12c0.552,0,1-0.447,1-1s-0.448-1-1-1h-5v-5.051c8.356-0.52,15-7.465,15-15.949v-6C45,28.447,44.552,28,44,28z" id="path-1"/>
                            <path d="M29,46c6.065,0,11-4.935,11-11V11c0-6.065-4.935-11-11-11S18,4.935,18,11v24C18,41.065,22.935,46,29,46z"/>
                        </g>
                        </svg>
                    <span class="record-text">Record calls</span>
                    <div class="radio-button" 
                         @click="isNotify"
                         :class="callflow.workflow.items[0].record.notify_the_caller ? 'active': ''">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                            <title>Components / Field / Radio / Default</title>
                            <desc>Created with Sketch.</desc>
                            <defs></defs>
                            <g id="Components-/-Field-/-Radio-/-Default" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <rect stroke="#BDBFD8" fill="#FFFFFF" x="0.5" y="0.5" width="23" height="23" rx="11.5"></rect>
                            </g>
                        </svg>
                    </div>
                    <span class="radio-text">Do I need to notify the caller?</span>
                </div>
                <div class="vertical-line"></div>
                <secondary-button @click.native="InsertStep(0)" v-if="!insertStepbuttons[0]" class="insert-step">+ Insert Step Here</secondary-button>
                <next-section v-else></next-section>
                <div class="vertical-arrow">
                    <div class="vertical-line"></div>
                    <!--<svg class="svg-arrow-bottom"-->
                    <!--width="30px"-->
                    <!--height="30px"-->
                    <!--viewBox="0 0 30 30"-->
                    <!--version="1.1">-->
                    <!--<path-->
                    <!--transform="translate(14.500000, 15.238427) rotate(-90.000000) translate(-14.500000, -15.238427) "-->
                    <!--d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"-->
                    <!--id="path-1">-->
                    <!--</path>-->
                    <!--</svg>-->
                    <svg class="svg-arrow-bottom"
                         width="30px"
                         height="30px"
                         viewBox="0 0 30 30"
                         version="1.1">
                        <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                              id="path-1">
                        </path>
                    </svg>
                </div>
                <div class="section-container greeting-container" id="greeting">
                    <div class="section-icon">
                        <svg class="svg-greeting"
                             width="30px"
                             height="30px"
                             viewBox="0 0 30 30"
                             version="1.1">
                            <path d="M31.25,13.9172814 C31.25,6.672798 24.4410278,0.75 16,0.75 C7.55897218,0.75 0.75,6.672798 0.75,13.9172814 C0.75,16.7162869 1.76166664,19.3779082 3.62330006,21.6046209 C4.40339287,22.5373107 4.78726221,23.7348292 4.6477264,24.9033811 C4.47765319,26.3299681 3.62497752,27.642961 2.02076721,28.763238 C1.82947102,28.8969925 1.92060972,29.2140316 2.16084198,29.2284006 C4.86329986,29.3902683 8.13496536,28.6928887 11.96316,26.7828564 L12.1965639,26.6664023 L12.451859,26.719913 C13.6050082,26.9616168 14.7917672,27.0845627 16,27.0845627 C24.4410278,27.0845627 31.25,21.1617647 31.25,13.9172814 Z"
                                  id="Shape" stroke="#FFFFFF" stroke-width="1.5" fill-rule="nonzero"></path>
                            <path d="M8.75,10 L21.25,10 C21.6642136,10 22,10.3357864 22,10.75 C22,11.1642136 21.6642136,11.5 21.25,11.5 L8.75,11.5 C8.33578644,11.5 8,11.1642136 8,10.75 C8,10.3357864 8.33578644,10 8.75,10 Z M8.75,13.5 L23.25,13.5 C23.6642136,13.5 24,13.8357864 24,14.25 C24,14.6642136 23.6642136,15 23.25,15 L8.75,15 C8.33578644,15 8,14.6642136 8,14.25 C8,13.8357864 8.33578644,13.5 8.75,13.5 Z M8.75,17 L19.25,17 C19.6642136,17 20,17.3357864 20,17.75 C20,18.1642136 19.6642136,18.5 19.25,18.5 L8.75,18.5 C8.33578644,18.5 8,18.1642136 8,17.75 C8,17.3357864 8.33578644,17 8.75,17 Z"
                                  id="Combined-Shape" fill="#FFFFFF"></path>
                        </svg>
                    </div>
                    <div class="container-title">
                        Greeting
                        <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <polygon
                                    points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                        </svg>
                    </div>
                    <div class="container-subtitle">
                        Play a message to the caller. Frequently used to notify the caller about call recording.
                    </div>
                    <div class="section-message-container">
                        <nav class="nav-header">
                            <p @click="isGreetingMessage = true"
                                :class="isGreetingMessage ? 'active' : ''">Read Message</p>
                            <p @click="isGreetingMessage = false"
                                :class="!isGreetingMessage ? 'active' : ''">Play Recording</p>
                        </nav>
                        <div class="col-wrapper">
                            <div v-if="isGreetingMessage" class="col">
                                <p class="text-area-title">
                                    Read the following text to the caller with a robot like-voice</p>
                                <text-area placeholder="This call will be recorded for quality assurance."
                                           value="This call will be recorded for quality assurance."
                                           maxlength="160"
                                           class="text-area"
                                           />
                            </div>
                            <div v-else class="col">
                                <div class="upload-container">
                                    <p class="pimary-input-title">Add Attachment</p>
                                    <app-dropzone
                                        @fileAdd="fileAdded($event)"
                                        class="upload-photo"
                                    ></app-dropzone>
                                </div>
                            </div>
                        </div>
                        <p class="preview-message-btn">Preview message</p>
                    </div>
                </div>

                <div class="vertical-line"></div>
                <secondary-button @click.native="InsertStep(1)" v-if="!insertStepbuttons[1]" class="insert-step">+ Insert Step Here</secondary-button>
                <next-section v-else></next-section>
                <div class="vertical-arrow">
                    <div class="vertical-line"></div>
                    <svg class="svg-arrow-bottom"
                         width="30px"
                         height="30px"
                         viewBox="0 0 30 30"
                         version="1.1">
                        <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                              id="path-1">
                        </path>
                    </svg>
                </div>
                <div class="section-container dial-container" id="dial">
                    <div class="section-icon">
                        <svg class="svg-greeting"
                             width="30px"
                             height="30px"
                             viewBox="0 0 30 30"
                             version="1.1">
                            <path d="M29.2451105,23.7992835 C29.1981628,23.6011294 29.0633839,23.4298657 28.8099513,23.2726268 L22.8570784,19.7541005 L22.8225214,19.7541005 L22.6442756,19.6470397 C22.562494,19.5979187 22.4073607,19.5634229 22.1730096,19.5634229 C21.8488343,19.5634229 21.5816246,19.6652845 21.3741839,19.8473614 L19.5593808,21.6952191 C19.421692,21.8329976 19.256152,21.9221758 19.0595866,21.9878473 C18.8928369,22.0434364 18.7604384,22.0740118 18.6159084,22.0740118 L18.4685996,22.0594029 L18.0722351,21.9800056 C17.7250135,21.9107068 17.2885701,21.7348411 16.7344979,21.4517262 C16.1968864,21.1770223 15.5463255,20.7597406 14.7759223,20.198179 C13.9970344,19.6302245 13.1201247,18.8459756 12.1524515,17.855788 C11.1504608,16.8749409 10.3718401,16.0025636 9.81476578,15.2333 C9.2634134,14.4719378 8.85103508,13.8195093 8.58122706,13.2793603 C8.25373294,12.6473528 8.0383562,12.0726405 7.93870381,11.5491244 L7.92547453,11.4088786 C7.92547453,11.2538132 7.9564076,11.099047 8.01155408,10.9334997 C8.0768944,10.737351 8.16611486,10.5715479 8.30376623,10.4338068 L9.85995263,8.87660609 C10.0308465,8.70560088 10.1412521,8.49764307 10.1964242,8.2354045 C10.2442413,8.0081253 10.2178116,7.82299649 10.1079925,7.62706535 L6.74049447,1.22873965 C6.64027229,1.07114499 6.52190637,0.942251072 6.38327033,0.838206264 C6.30279464,0.777810157 6.2175657,0.75 6.10300313,0.75 C5.92647753,0.75 5.77655505,0.815633837 5.61722097,0.975071769 L1.36468776,5.22891011 C1.22890785,5.35119167 1.10604867,5.52113711 0.998379079,5.74431235 C0.889404698,5.97019213 0.819171257,6.18575794 0.78539652,6.39184375 C0.781702971,6.49299005 0.771703227,6.68496357 0.754139916,7.00130922 C0.736422125,7.32043733 0.774826787,7.79600478 0.873067276,8.41532326 C0.97228098,9.04077699 1.1642697,9.79912117 1.44972762,10.6866578 C1.73206484,11.5644917 2.16004443,12.5535361 2.73426216,13.6513211 C3.30864219,14.7495126 4.0724172,15.9527385 5.02568146,17.2591979 C5.9742604,18.5591348 7.17588034,19.9273739 8.63736291,21.3690042 C10.465672,23.2193456 12.1832552,24.6688686 13.7864503,25.7176765 C15.4020562,26.7746543 16.8389429,27.5631564 18.0937091,28.0836815 C19.3445163,28.6025885 20.3902445,28.9245882 21.2225877,29.0520188 C22.087423,29.1844238 22.7074031,29.25 23.0624147,29.25 C23.2080907,29.25 23.3224207,29.2455662 23.4004851,29.2377816 C23.4889536,29.2289333 23.5471889,29.2234853 23.5923818,29.2206056 C23.7997584,29.1872431 24.0168747,29.1167242 24.2449028,29.0065315 C24.4674044,28.8991598 24.6371409,28.7762523 24.7886528,28.6095777 L29.0104966,24.4169099 C29.2007239,24.2265037 29.2702307,24.0402315 29.2451105,23.7992835 Z M9.43420582,11.408767 C9.43441065,11.4082869 9.43456427,11.4078858 9.4346717,11.4075633 C9.43404097,11.4094567 9.43345307,11.4112309 9.43290513,11.4128812 Z M18.5793266,20.566796 C18.5809879,20.5662378 18.5827995,20.5656377 18.5847344,20.5649927 C18.5841234,20.5651969 18.5832137,20.5655763 18.5819949,20.5661751 Z"
                                  id="Shape" stroke="#FFFFFF" stroke-width="1.5" fill-rule="nonzero"></path>
                            <path d="M27.4393398,1.5 L21,1.5 L21,0 L30,0 L30,9 L28.5,9 L28.5,2.56066017 L17.802408,13.2582521 C17.5095148,13.5511454 17.0346411,13.5511454 16.7417479,13.2582521 C16.4488546,12.9653589 16.4488546,12.4904852 16.7417479,12.197592 L27.4393398,1.5 Z"
                                  id="Combined-Shape" fill="#FFFFFF"></path>
                        </svg>
                    </div>
                    <div class="container-title">
                        Dial
                        <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <polygon
                                    points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                        </svg>
                    </div>
                    <div class="container-subtitle">
                        This is where the phone will ring when customers dial your tracking number.
                    </div>
                    <div class="section-message-container">
                        <div class="destination-number">
                            <div class="primary-input-container">
                                <p class="primary-input-title">Destination Number</p>
                                <primary-select
                                        class="discount-number"
                                >
                                    <option value="" disabled hidden selected>Number</option>
                                </primary-select>
                            </div>
                            <primary-input
                                    class="dial-input"
                                    type="text"
                                    v-model="callflow.workflow.items[1].dial.destination"
                                    placeholder=""
                                    name=" "/>
                        </div>
                        <div class="voicemails">
                            <svg v-if="callflow.workflow.items[1].dial.prevent_answering" 
                                @click="callflow.workflow.items[1].dial.prevent_answering = !callflow.workflow.items[1].dial.prevent_answering"
                                class="check-icon active" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <rect x="0.5" y="0.5" width="23" height="23" rx="4"></rect>
                                <g transform="translate(12.000000, 10.000000) rotate(-45.000000) translate(-12.000000, -10.000000) translate(5.000000, 6.000000)" fill="#24E2B8">
                                    <rect x="0" y="6" width="14" height="2" rx="1"></rect>
                                    <rect x="0" y="0" width="2" height="8" rx="1"></rect>
                                </g>
                            </svg>
                            <svg v-else 
                                @click="callflow.workflow.items[1].dial.prevent_answering = !callflow.workflow.items[1].dial.prevent_answeringswering"
                                class="check-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect stroke="#BDBFD8" fill="#FFFFFF" x="0.5" y="0.5" width="23" height="23" rx="4"></rect>
                                </g>
                            </svg>
                            <p class="voicemails-title">
                                Prevent voicemails and automated systems from answering a call.
                            </p>
                        </div>
                        <div class="seconds">
                            <p>If the destination does not answer within </p>
                            <primary-select
                                    class="seconds-select"
                                    v-model="callflow.workflow.items[1].dial.timeout">
                                <!-- <option value="" disabled hidden selected>20 seconds</option> -->
                                <option v-for="(i, k) in dialTimeout"
                                        :key="k"
                                        :value="i"
                                        >{{i}} seconds</option>
                            </primary-select>
                            <p> then go to the next step.</p>
                        </div>
                    </div>
                </div>

                <div class="vertical-line"></div>
                <p class="insert-step-title">If call is not answered</p>
                <div class="vertical-arrow">
                    <div class="vertical-line"></div>
                    <svg class="svg-arrow-bottom"
                         width="30px"
                         height="30px"
                         viewBox="0 0 30 30"
                         version="1.1">
                        <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                              id="path-1">
                        </path>
                    </svg>
                </div>
                <div class="section-container simulcall-container" id="simulcall">
                    <div class="section-icon">
                        <svg class="svg-simulcall" viewBox="0 0 36 32" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path d="M10.774302,9.64814387 C10.7896146,9.69613141 10.8083497,9.72442409 10.8443603,9.77880535 C10.901167,9.85535364 10.901167,9.85535364 10.9375759,9.8924952 L10.7825473,9.66676897 C10.7779843,9.65650728 10.7771439,9.65461719 10.774302,9.64814387 Z M28.6572911,17.6552483 C26.0369929,16.9325014 23.47419,15.4462867 22.4580607,13.7782072 C21.7396658,12.605901 21.6536459,11.2526949 22.2387716,10.0806725 L12.7746783,10.0806725 C13.3596223,11.252826 13.2758089,12.6029534 12.5588735,13.777964 C11.5391524,15.4491736 8.97660313,16.9348505 6.35489123,17.6573521 L5.75470467,27.7223767 C5.7098468,28.4804747 6.16095191,29.0430016 6.70169492,29.0430016 L28.3115364,29.0430016 C28.8515818,29.0430016 29.3020886,28.4803647 29.2565741,27.7226419 L28.6572911,17.6552483 Z M22.2729751,10.0148696 C22.2899999,9.98386448 22.3091591,9.95090075 22.3387671,9.90082708 C22.3400077,9.89873115 22.3400077,9.89873115 22.3412409,9.89664851 C22.3633172,9.85942387 22.3633172,9.85942387 22.3808154,9.82964184 L22.8111536,10.0806725 L22.2712831,10.0806725 C22.2714347,10.0588881 22.2719991,10.0369562 22.2729751,10.0148696 Z M11.5333516,9.29671952 L12.1434867,9.03523302 C12.1465572,9.04239424 12.1465572,9.04239424 12.1472222,9.04392824 C12.1472496,9.04399121 12.1472496,9.04399121 12.1472592,9.04401318 C12.148063,9.0458514 12.148063,9.0458514 12.1532646,9.05756127 L11.467906,9.36216512 L11.5333516,9.29671952 Z M12.1324698,9.00960745 C12.1706382,9.07569306 12.1792648,9.12726127 12.2188901,9.36413341 L11.4688901,9.36413341 L12.1002643,8.95932892 C12.1111449,8.97629951 12.1218793,8.99305764 12.1324698,9.00960745 Z M17.5339311,5.98160897 L17.5071077,5.98177881 L17.4806694,5.98161141 C17.4557093,5.98167936 17.447742,5.98173752 17.4113067,5.98200348 L17.4036905,5.98206041 C17.3553287,5.98242121 17.3553287,5.98242121 17.3127392,5.98253144 L17.3127392,5.98300951 L16.9514762,5.98529695 L16.9514762,6.73253144 L18.0627392,6.73253144 L18.0627392,5.98529695 L17.7014762,5.98300951 L17.7014762,5.98253144 C17.6588848,5.9824212 17.6588848,5.9824212 17.6103809,5.98206025 L17.5937206,5.98193718 C17.5622263,5.98171899 17.5539901,5.98166193 17.5339311,5.98160897 Z M17.5071077,5.98177881 L17.3127392,5.98300951 L17.3127392,6.73253144 L17.7014762,6.73253144 L17.7014762,5.98300951 L17.5071077,5.98177881 Z M17.5071815,1.02613121 L18.0627392,1.01617011 L18.0627392,0.267687261 L16.9514762,0.267687261 L16.9514762,1.01615933 L17.5071815,1.02613121 Z"
                                  stroke="#70828B" stroke-width="1.5"></path>
                            <path d="M13.9745216,24.3723346 L11.945216,24.3723346 C11.5712411,24.3723346 11.2681247,24.068234 11.2681247,23.6952433 C11.2681247,23.3222526 11.5712411,23.018152 11.945216,23.018152 L13.9745216,23.018152 C14.3475123,23.018152 14.6516129,23.3222526 14.6516129,23.6952433 C14.6516129,24.068234 14.3475123,24.3723346 13.9745216,24.3723346 Z M13.9745216,21.7919081 L11.945216,21.7919081 C11.5712411,21.7919081 11.2681247,21.4887917 11.2681247,21.115801 C11.2681247,20.7398578 11.5712411,20.4387097 11.945216,20.4387097 L13.9745216,20.4387097 C14.3475123,20.4387097 14.6516129,20.7398578 14.6516129,21.115801 C14.6516129,21.4887917 14.3475123,21.7919081 13.9745216,21.7919081 Z M13.9745216,19.2114817 L11.945216,19.2114817 C11.5712411,19.2114817 11.2681247,18.9083652 11.2681247,18.5343904 C11.2681247,18.1613997 11.5712411,17.8572991 11.945216,17.8572991 L13.9745216,17.8572991 C14.3475123,17.8572991 14.6516129,18.1613997 14.6516129,18.5343904 C14.6516129,18.9073811 14.3475123,19.2114817 13.9745216,19.2114817 Z M18.5222526,24.3723346 L16.4939311,24.3723346 C16.1199563,24.3723346 15.8168398,24.068234 15.8168398,23.6952433 C15.8168398,23.3222526 16.1209404,23.018152 16.4939311,23.018152 L18.5232367,23.018152 C18.8962274,23.018152 19.200328,23.3222526 19.200328,23.6952433 C19.1983598,24.068234 18.8952433,24.3723346 18.5222526,24.3723346 Z M18.5222526,21.7919081 L16.4939311,21.7919081 C16.1199563,21.7919081 15.8168398,21.4887917 15.8168398,21.115801 C15.8168398,20.7398578 16.1209404,20.4387097 16.4939311,20.4387097 L18.5232367,20.4387097 C18.8962274,20.4387097 19.200328,20.7398578 19.200328,21.115801 C19.1983598,21.4887917 18.8952433,21.7919081 18.5222526,21.7919081 Z M18.5222526,19.2114817 L16.4939311,19.2114817 C16.1199563,19.2114817 15.8168398,18.9083652 15.8168398,18.5343904 C15.8168398,18.1613997 16.1209404,17.8572991 16.4939311,17.8572991 L18.5232367,17.8572991 C18.8962274,17.8572991 19.200328,18.1613997 19.200328,18.5343904 C19.1983598,18.9073811 18.8952433,19.2114817 18.5222526,19.2114817 Z M23.0689995,24.3723346 L21.0396938,24.3723346 C20.6667031,24.3723346 20.3635867,24.068234 20.3635867,23.6952433 C20.3635867,23.3222526 20.6667031,23.018152 21.0396938,23.018152 L23.0689995,23.018152 C23.4439584,23.018152 23.7460908,23.3222526 23.7460908,23.6952433 C23.7460908,24.068234 23.4449426,24.3723346 23.0689995,24.3723346 Z M23.0689995,21.7919081 L21.0396938,21.7919081 C20.6667031,21.7919081 20.3635867,21.4887917 20.3635867,21.115801 C20.3635867,20.7398578 20.6667031,20.4387097 21.0396938,20.4387097 L23.0689995,20.4387097 C23.4439584,20.4387097 23.7460908,20.7398578 23.7460908,21.115801 C23.7460908,21.4887917 23.4449426,21.7919081 23.0689995,21.7919081 Z M23.0689995,19.2114817 L21.0396938,19.2114817 C20.6667031,19.2114817 20.3635867,18.9083652 20.3635867,18.5343904 C20.3635867,18.1613997 20.6667031,17.8572991 21.0396938,17.8572991 L23.0689995,17.8572991 C23.4439584,17.8572991 23.7460908,18.1613997 23.7460908,18.5343904 C23.7460908,18.9073811 23.4449426,19.2114817 23.0689995,19.2114817 Z"
                                  stroke="#70828B" stroke-width="1" fill="#70828B"></path>
                            <g transform="translate(38.5, 10)  rotate(135)">
                                <path d="M29.2451105,23.7992835 C29.1981628,23.6011294 29.0633839,23.4298657 28.8099513,23.2726268 L22.8570784,19.7541005 L22.8225214,19.7541005 L22.6442756,19.6470397 C22.562494,19.5979187 22.4073607,19.5634229 22.1730096,19.5634229 C21.8488343,19.5634229 21.5816246,19.6652845 21.3741839,19.8473614 L19.5593808,21.6952191 C19.421692,21.8329976 19.256152,21.9221758 19.0595866,21.9878473 C18.8928369,22.0434364 18.7604384,22.0740118 18.6159084,22.0740118 L18.4685996,22.0594029 L18.0722351,21.9800056 C17.7250135,21.9107068 17.2885701,21.7348411 16.7344979,21.4517262 C16.1968864,21.1770223 15.5463255,20.7597406 14.7759223,20.198179 C13.9970344,19.6302245 13.1201247,18.8459756 12.1524515,17.855788 C11.1504608,16.8749409 10.3718401,16.0025636 9.81476578,15.2333 C9.2634134,14.4719378 8.85103508,13.8195093 8.58122706,13.2793603 C8.25373294,12.6473528 8.0383562,12.0726405 7.93870381,11.5491244 L7.92547453,11.4088786 C7.92547453,11.2538132 7.9564076,11.099047 8.01155408,10.9334997 C8.0768944,10.737351 8.16611486,10.5715479 8.30376623,10.4338068 L9.85995263,8.87660609 C10.0308465,8.70560088 10.1412521,8.49764307 10.1964242,8.2354045 C10.2442413,8.0081253 10.2178116,7.82299649 10.1079925,7.62706535 L6.74049447,1.22873965 C6.64027229,1.07114499 6.52190637,0.942251072 6.38327033,0.838206264 C6.30279464,0.777810157 6.2175657,0.75 6.10300313,0.75 C5.92647753,0.75 5.77655505,0.815633837 5.61722097,0.975071769 L1.36468776,5.22891011 C1.22890785,5.35119167 1.10604867,5.52113711 0.998379079,5.74431235 C0.889404698,5.97019213 0.819171257,6.18575794 0.78539652,6.39184375 C0.781702971,6.49299005 0.771703227,6.68496357 0.754139916,7.00130922 C0.736422125,7.32043733 0.774826787,7.79600478 0.873067276,8.41532326 C0.97228098,9.04077699 1.1642697,9.79912117 1.44972762,10.6866578 C1.73206484,11.5644917 2.16004443,12.5535361 2.73426216,13.6513211 C3.30864219,14.7495126 4.0724172,15.9527385 5.02568146,17.2591979 C5.9742604,18.5591348 7.17588034,19.9273739 8.63736291,21.3690042 C10.465672,23.2193456 12.1832552,24.6688686 13.7864503,25.7176765 C15.4020562,26.7746543 16.8389429,27.5631564 18.0937091,28.0836815 C19.3445163,28.6025885 20.3902445,28.9245882 21.2225877,29.0520188 C22.087423,29.1844238 22.7074031,29.25 23.0624147,29.25 C23.2080907,29.25 23.3224207,29.2455662 23.4004851,29.2377816 C23.4889536,29.2289333 23.5471889,29.2234853 23.5923818,29.2206056 C23.7997584,29.1872431 24.0168747,29.1167242 24.2449028,29.0065315 C24.4674044,28.8991598 24.6371409,28.7762523 24.7886528,28.6095777 L29.0104966,24.4169099 C29.2007239,24.2265037 29.2702307,24.0402315 29.2451105,23.7992835 Z M9.43420582,11.408767 C9.43441065,11.4082869 9.43456427,11.4078858 9.4346717,11.4075633 C9.43404097,11.4094567 9.43345307,11.4112309 9.43290513,11.4128812 Z M18.5793266,20.566796 C18.5809879,20.5662378 18.5827995,20.5656377 18.5847344,20.5649927 C18.5841234,20.5651969 18.5832137,20.5655763 18.5819949,20.5661751 Z"
                                      stroke="#70828B" stroke-width="1.5" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </div>
                    <div class="container-title">
                        Simulcall
                        <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <polygon
                                    points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                        </svg>
                    </div>
                    <div class="container-subtitle">
                        We'll dial all numbers in the Simulcall at the same time. The first person to answer will be connected to the caller.
                    </div>
                    <div class="section-message-container">
                        <div class="ring-checkbox">
                            <div>
                                <svg v-if="!callflow.workflow.items[2].simulcall.ring_at_once" 
                                    @click="callflow.workflow.items[2].simulcall.ring_at_once = !callflow.workflow.items[2].simulcall.ring_at_once"
                                    class="check-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect stroke="#24E2B8" stroke-width="3" fill="#24E2B8" x="1" y="1" width="22" height="22" rx="11"></rect>
                                    <circle fill="#FFFFFF" cx="12" cy="12" r="7"></circle>
                                </svg>
                                <img v-else class="check-icon"
                                     @click="callflow.workflow.items[2].simulcall.ring_at_once = !callflow.workflow.items[2].simulcall.ring_at_once"
                                     src="@/assets/Icon/Radio/Default.svg"
                                     alt="">
                                <p>Ring in sequence</p>
                            </div>
                            <div>
                                <svg v-if="callflow.workflow.items[2].simulcall.ring_at_once" 
                                    @click="callflow.workflow.items[2].simulcall.ring_at_once = !callflow.workflow.items[2].simulcall.ring_at_once"
                                    class="check-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect stroke="#24E2B8" stroke-width="3" fill="#24E2B8" x="1" y="1" width="22" height="22" rx="11"></rect>
                                    <circle fill="#FFFFFF" cx="12" cy="12" r="7"></circle>
                                </svg>
                                <img v-else class="check-icon"
                                     @click="callflow.workflow.items[2].simulcall.ring_at_once = !callflow.workflow.items[2].simulcall.ring_at_once"
                                     src="@/assets/Icon/Radio/Default.svg"
                                     alt="">
                                <p>Ring all at once</p>
                            </div>
                        </div>
                        <div class="destination-number">
                            <div class="destination-number-row">
                                <p class="primary-input-title">Destination Number</p>
                                <div class="primary-input-container"
                                    v-for="(destination, k) in callflow.workflow.items[2].simulcall.destinations" :key="k">
                                    <primary-input
                                        class="simulcall-input"
                                        type="text"
                                        v-model="callflow.workflow.items[2].simulcall.destinations[k]"
                                        placeholder=""
                                        name=" "/>
                                    <img @click="callflow.workflow.items[2].simulcall.destinations.splice(k,1)" 
                                        class="simpulcall-close"
                                        src="@/assets/Icon/close-normal.svg"
                                        alt="">
                                </div>
                            </div>
                            <div class="add-number-container" @click="callflow.workflow.items[2].simulcall.destinations.push('')">
                                <svg class="simulcall-add-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <polygon
                                            points="24 10 14 10 14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14"></polygon>
                                </svg>
                                <p class="add-number">Add Number</p>
                            </div>
                        </div>
                        <div class="voicemails">
                            <div>
                                <svg v-if="callflow.workflow.items[2].simulcall.prevent_answering" 
                                    @click="callflow.workflow.items[2].simulcall.prevent_answering = !callflow.workflow.items[2].simulcall.prevent_answering" 
                                    class="check-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect x="0.5" y="0.5" width="23" height="23" rx="4"></rect>
                                    <g transform="translate(12.000000, 10.000000) rotate(-45.000000) translate(-12.000000, -10.000000) translate(5.000000, 6.000000)" fill="#51A3F3">
                                        <rect x="0" y="6" width="14" height="2" rx="1"></rect>
                                        <rect x="0" y="0" width="2" height="8" rx="1"></rect>
                                    </g>
                                </svg>
                                <img v-else 
                                     @click="callflow.workflow.items[2].simulcall.prevent_answering = !callflow.workflow.items[2].simulcall.prevent_answering"
                                     class="check-icon"
                                     src="@/assets/Icon/Check/Default.svg"
                                     alt="">
                                <p class="voicemails-title">
                                    Prevent voicemails and automated systems from answering a call.</p>
                            </div>
                            <div>
                                <svg v-if="!callflow.workflow.items[2].simulcall.prevent_answering" 
                                    @click="callflow.workflow.items[2].simulcall.prevent_answering = !callflow.workflow.items[2].simulcall.prevent_answering" 
                                    class="check-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect x="0.5" y="0.5" width="23" height="23" rx="4"></rect>
                                    <g transform="translate(12.000000, 10.000000) rotate(-45.000000) translate(-12.000000, -10.000000) translate(5.000000, 6.000000)" fill="#51A3F3">
                                        <rect x="0" y="6" width="14" height="2" rx="1"></rect>
                                        <rect x="0" y="0" width="2" height="8" rx="1"></rect>
                                    </g>
                                </svg>
                                <img v-else 
                                     @click="callflow.workflow.items[2].simulcall.prevent_answering = !callflow.workflow.items[2].simulcall.prevent_answering"
                                     class="check-icon"
                                     src="@/assets/Icon/Check/Default.svg"
                                     alt="">
                                <p class="voicemails-title">
                                    Route previous callers to the number that answered last time they called.</p>
                            </div>
                        </div>
                        <div class="seconds">
                            <p>If the destination does not answer within </p>
                            <primary-select
                                    class="seconds-select"
                                    v-model="callflow.workflow.items[2].simulcall.timeout">
                                <!-- <option value="" disabled hidden selected>20 seconds</option> -->
                                <option v-for="(i, k) in dialTimeout"
                                        :key="k"
                                        :value="i"
                                        >{{i}} seconds</option>
                            </primary-select>
                            <p> then go to the next step.</p>
                        </div>
                    </div>
                </div>

                <div class="vertical-line"></div>
                <secondary-button @click.native="InsertStep(2)" v-if="!insertStepbuttons[2]" class="insert-step">+ Insert Step Here</secondary-button>
                <next-section v-else></next-section>
                <div class="vertical-arrow">
                    <div class="vertical-line"></div>
                    <svg class="svg-arrow-bottom"
                         width="30px"
                         height="30px"
                         viewBox="0 0 30 30"
                         version="1.1">
                        <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                              id="path-1">
                        </path>
                    </svg>
                </div>
                <div class="section-container menu-container" id="menu">
                    <div class="section-icon">
                        <img class="svg-menu"
                             src="@/assets/Icon/Callflow/Menu.svg"
                             alt="">
                    </div>
                    <div class="container-title">
                        Menu
                        <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <polygon
                                    points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                        </svg>
                    </div>
                    <div class="container-subtitle">
                        Prompt the caller to select from a menu of options using the keypad on their phone.
                    </div>
                    <div class="section-message-container">
                        <nav class="nav-header">
                            <p @click="isMenuMessage = true"
                                :class="isMenuMessage ? 'active' : ''">Read Message</p>
                            <p @click="isMenuMessage = false"
                                :class="!isMenuMessage ? 'active' : ''">Play Recording</p>
                        </nav>
                        <div class="col-wrapper">
                            <div v-if="isMenuMessage" class="col">
                                <p class="text-area-title">
                                    Read the following text to the caller with a robot like-voice</p>
                                <text-area placeholder="Press 1 for Sales, press 2 for Support."
                                           maxlength="160"
                                           count=''
                                           value="Press 1 for Sales, press 2 for Support."
                                           class="text-area"
                                           />
                            </div>
                            <div v-else class="col">
                                <div class="upload-container">
                                    <p class="pimary-input-title">Add Attachment</p>
                                    <app-dropzone
                                        @fileAdd="fileAdded($event)"
                                        class="upload-photo"
                                    ></app-dropzone>
                                </div>
                            </div>
                        </div>
                        <p class="preview-message-btn">Preview message</p>
                        <p class="primary-select-title">If the caller</p>
                        <div class="seconds">
                                <primary-select
                                        class="seconds-select"
                                        v-model="callflow.workflow.items[3].menu.items[0].pressed"
                                        >
                                    <option value="1" selected>Presses 1</option>
                                    <option value="2" >Presses 2</option>
                                </primary-select>
                            <!-- <primary-input
                                    class="menu-input"
                                    type="text"
                                    placeholder="Forward to Sales"
                                    :disabled='true'
                                    name=" "/> -->
                                 <primary-select
                                        class="menu-input"
                                        >
                                    <option v-for="(type, i) in menuTypes" :key="i" :value="type" selected>{{type}}</option>
                                </primary-select>
                            <img class="check-icon"
                                 src="@/assets/Icon/close-normal.svg"
                                 alt="">
                        </div>
                        <div v-if="callflow.workflow.items[3].menu.items[0].pressed == '2'" class="seconds notActive">
                            <p class="bold">Any other time</p>
                        </div>

                        <!-- <div class="seconds notActive">
                            <primary-select
                                    class="seconds-select">
                                <option value="1">Presses 1</option>
                                <option value="2" selected>Presses 2</option>
                            </primary-select>
                            <primary-input
                                    class="menu-input"
                                    type="text"
                                    :disabled='true'
                                    placeholder="Forward to Support"
                                    name=" "/>
                            <img class="check-icon"
                                 src="@/assets/Icon/close-normal.svg"
                                 alt="">
                        </div> -->
                        <div class="add-number-container">
                            <svg class="menu-add-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <polygon
                                        points="24 10 14 10 14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14"></polygon>
                            </svg>
                            <p class="add-number">Add Number</p>
                        </div>
                    </div>
                </div>

                <div v-if="callflow.workflow.items[3].menu.items[0].pressed == '2'" class="warning">
                    <div class="warning-line"></div>
                    <div class="warning-cycle">
                        <svg class="warning-icon" width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <defs></defs>
                            <g id="Company-Admin" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="03-Company-Admin---0011-Dids---05-Call-flow---b.-Create" transform="translate(-1077.000000, -3807.000000)" fill="#FFB9BF" fill-rule="nonzero">
                                    <g id="Wizard-Content" transform="translate(320.000000, 305.000000)">
                                        <g id="Schedule" transform="translate(0.000000, 2831.000000)">
                                            <g id="Any">
                                                <g transform="translate(1.000000, 650.000000)">
                                                    <g id="Alert" transform="translate(699.000000, 5.000000)">
                                                        <g id="icon--alert" transform="translate(57.000000, 16.000000)">
                                                            <path d="M15.608,14.239 L8.441,0.3365 C8.253,-0.0285 7.747,-0.0285 7.5585,0.3365 L0.392,14.239 C0.2145,14.584 0.456,15 0.8335,15 L15.167,15 C15.544,15 15.7855,14.584 15.608,14.239 Z M9,13 L7,13 L7,11 L9,11 L9,13 Z M9,10 L7,10 L7,5 L9,5 L9,10 Z" id="Shape"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div v-if="callflow.workflow.items[3].menu.items[0].pressed == '1'">
                    <div class="to-next-step menu-next-step">
                        <div class="horizontal-short-line"></div>
                        <div class="vertical-line"></div>
                        <div class="horizontal-long-line"></div>
                    </div>
                    <div class="vertical-line"></div>
                    <p class="insert-step-title">The caller pressed '1'</p>
                    <div class="vertical-line"></div>
                    <secondary-button @click.native="InsertStep(3)" v-if="!insertStepbuttons[3]" class="insert-step">+ Insert Step Here</secondary-button>
                    <next-section v-else></next-section>
                    <div class="vertical-arrow">
                        <div class="vertical-line"></div>
                        <svg class="svg-arrow-bottom"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1">
                            <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                                id="path-1">
                            </path>
                        </svg>
                    </div>
                    <div class="section-container schedule-container" id="schedule">
                        <div class="section-icon">
                            <svg class="svg-schedule"
                                width="30px"
                                height="30px"
                                viewBox="0 0 30 30"
                                version="1.1">
                                <path fill="#ffffff" id="Shape"
                                    d="m14.60156,0c3.80006,0 7.25423,1.45833 9.84967,3.8393l2.9267,-2.9267l0,6.38818c0,1.00842 -0.81676,1.8252 -1.8252,1.8252l-6.38818,0l3.99354,-3.99353c-2.26599,-2.05243 -5.26571,-3.30725 -8.55653,-3.30725c-7.04524,0 -12.77637,5.73111 -12.77637,12.77637c0,7.04526 5.73113,12.77637 12.77637,12.77637c7.04524,0 12.77637,-5.73111 12.77637,-12.77637c0,-0.93997 -0.1095,-1.8544 -0.30298,-2.73779l1.86263,0c0.16883,0.88797 0.26555,1.80147 0.26555,2.73779c0,8.06462 -6.53692,14.60156 -14.60156,14.60156c-8.06464,0 -14.60156,-6.53694 -14.60156,-14.60156c0,-8.06463 6.53693,-14.60156 14.60156,-14.60156z"/>
                                <polygon fill="#ffffff"
                                        points="21.810165192324348,20.611935725566582 14.601562779396772,13.40241055055867 14.601562779396772,7.300780922240392 12.776367431972176,7.300780922240392 12.776367431972176,14.548628771061885 12.773635607454707,14.551371814571212 20.32264841100732,22.100376203879932 "
                                        id="Shape"/>
                            </svg>
                        </div>
                        <div class="container-title">
                            Schedule
                            <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <polygon
                                        points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                            </svg>
                        </div>
                        <div class="container-subtitle">
                            Create a schedule that determines how your calls should be routed.<br/>Time Zone: Athens
                        </div>
                        <div class="section-message-container">
                            <div v-for="(branch, k) in callflow.workflow.items[4].schedule.items" :key="k">
                                <div class="seconds">
                                    <p class="bold">Schedule Branch {{String.fromCharCode(65 + k)}}: </p>
                                    <p>If a call is received during the following times</p>
                                    <img @click="callflow.workflow.items[4].schedule.items.splice(k,1)"
                                        class="check-icon"
                                        src="@/assets/Icon/close-normal.svg"
                                        alt="">
                                </div>
                                <div v-if="k==0" class="message">
                                    <div class="message-line"></div>
                                    <div class="message-cycle">
                                        <svg class="svg"
                                            width="30px"
                                            height="30px"
                                            viewBox="0 0 30 30"
                                            version="1.1">
                                            <path d="M31.25,13.9172814 C31.25,6.672798 24.4410278,0.75 16,0.75 C7.55897218,0.75 0.75,6.672798 0.75,13.9172814 C0.75,16.7162869 1.76166664,19.3779082 3.62330006,21.6046209 C4.40339287,22.5373107 4.78726221,23.7348292 4.6477264,24.9033811 C4.47765319,26.3299681 3.62497752,27.642961 2.02076721,28.763238 C1.82947102,28.8969925 1.92060972,29.2140316 2.16084198,29.2284006 C4.86329986,29.3902683 8.13496536,28.6928887 11.96316,26.7828564 L12.1965639,26.6664023 L12.451859,26.719913 C13.6050082,26.9616168 14.7917672,27.0845627 16,27.0845627 C24.4410278,27.0845627 31.25,21.1617647 31.25,13.9172814 Z"
                                                id="Shape" stroke="#23C0FF" stroke-width="1.5" fill-rule="nonzero"></path>
                                            <path d="M8.75,10 L21.25,10 C21.6642136,10 22,10.3357864 22,10.75 C22,11.1642136 21.6642136,11.5 21.25,11.5 L8.75,11.5 C8.33578644,11.5 8,11.1642136 8,10.75 C8,10.3357864 8.33578644,10 8.75,10 Z M8.75,13.5 L23.25,13.5 C23.6642136,13.5 24,13.8357864 24,14.25 C24,14.6642136 23.6642136,15 23.25,15 L8.75,15 C8.33578644,15 8,14.6642136 8,14.25 C8,13.8357864 8.33578644,13.5 8.75,13.5 Z M8.75,17 L19.25,17 C19.6642136,17 20,17.3357864 20,17.75 C20,18.1642136 19.6642136,18.5 19.25,18.5 L8.75,18.5 C8.33578644,18.5 8,18.1642136 8,17.75 C8,17.3357864 8.33578644,17 8.75,17 Z"
                                                id="Combined-Shape" fill="#23C0FF"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="add-item">
                                    <div class="item" v-for="(time, i) in callflow.workflow.items[4].schedule.items[k].times" :key="i">
                                        <primary-select
                                                class="weekdays"
                                                v-model="time.weekdays">
                                            <option value="" disabled hidden selected>Weekdays</option>
                                            <option v-for="(weekday, k) in weekdays" :key="k" :value="k+1">{{weekday}}</option>
                                        </primary-select>
                                        <primary-select
                                                class="between"
                                                v-model="time.type"
                                                @input="updateTime(time)">
                                            <option value="Between" selected>Between</option>
                                            <option value="All day" selected>All day</option>
                                        </primary-select>
                                        <div v-if="time.type == 'Between'" class="between-container">
                                            <primary-select
                                                    class="from"
                                                    v-model="time.startHour"
                                                    @input="updateStart(time)">
                                                <option v-for="(hour, k) in hours" :key="k" :value="hour">{{hour}}</option>
                                            </primary-select>
                                            <span>:</span>
                                            <primary-select
                                                    class="to"
                                                    v-model="time.startSecond"
                                                    @input="updateStart(time)">
                                                <option v-for="(second, k) in seconds" :key="k" :value="second">{{second}}</option>
                                            </primary-select>
                                            <span class="ampersant">&</span>
                                            <primary-select
                                                    class="from"
                                                    v-model="time.stopHour"
                                                    @input="updateStop(time)">
                                                <option v-for="(hour, k) in hours" :key="k" :value="hour">{{hour}}</option>
                                            </primary-select>
                                            <span>:</span>
                                            <primary-select
                                                    class="to"
                                                    v-model="time.stopSecond"
                                                    @input="updateStop(time)">
                                                <option v-for="(second, k) in seconds" :key="k" :value="second">{{second}}</option>
                                            </primary-select>
                                        </div>
                                        <div v-else class="speace"></div>
                                        <img @click="callflow.workflow.items[4].schedule.items[k].times.splice(i,1)"
                                            class="check-icon"
                                            src="@/assets/Icon/close-normal.svg"
                                            alt="">
                                    </div>
                                    <!-- <div class="item">
                                        <primary-select
                                                class="weekdays">
                                            <option value="" disabled hidden selected>Weekdays</option>
                                        </primary-select>
                                        <primary-select
                                                class="between">
                                            <option value="" disabled hidden selected>All day</option>
                                        </primary-select>
                                        <div class="speace"></div>
                                        <img class="check-icon"
                                            src="@/assets/Icon/close-normal.svg"
                                            alt="">
                                    </div> -->
                                    <div class="add-button" @click="addScheduleTime(k)">
                                        <svg class="schedule-add-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <polygon
                                                    points="24 10 14 10 14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14"></polygon>
                                        </svg>
                                        <p class="add-number">Add Item</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="primary-button" @click="addScheduleBranch">
                                <primary-button>Add Schedlue Branch</primary-button>
                            </div> -->
                            <div class="seconds notActive">
                                <p class="bold">Any other time</p>
                            </div>
                        </div>
                    </div>
                    <div class="warning">
                        <div class="warning-line"></div>
                        <div class="warning-cycle">
                            <svg class="warning-icon" width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs></defs>
                                <g id="Company-Admin" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="03-Company-Admin---0011-Dids---05-Call-flow---b.-Create" transform="translate(-1077.000000, -3807.000000)" fill="#FFB9BF" fill-rule="nonzero">
                                        <g id="Wizard-Content" transform="translate(320.000000, 305.000000)">
                                            <g id="Schedule" transform="translate(0.000000, 2831.000000)">
                                                <g id="Any">
                                                    <g transform="translate(1.000000, 650.000000)">
                                                        <g id="Alert" transform="translate(699.000000, 5.000000)">
                                                            <g id="icon--alert" transform="translate(57.000000, 16.000000)">
                                                                <path d="M15.608,14.239 L8.441,0.3365 C8.253,-0.0285 7.747,-0.0285 7.5585,0.3365 L0.392,14.239 C0.2145,14.584 0.456,15 0.8335,15 L15.167,15 C15.544,15 15.7855,14.584 15.608,14.239 Z M9,13 L7,13 L7,11 L9,11 L9,13 Z M9,10 L7,10 L7,5 L9,5 L9,10 Z" id="Shape"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>

                    <div class="to-next-step schedule-next-step">
                        <div class="horizontal-short-line"></div>
                        <div class="vertical-line"></div>
                        <div class="horizontal-long-line"></div>
                    </div>
                    <div class="vertical-line"></div>
                    <p class="insert-step-title">The call is received during Schedule Branch B</p>
                    <div class="vertical-line"></div>
                    <secondary-button @click.native="InsertStep(4)" v-if="!insertStepbuttons[4]" class="insert-step">+ Insert Step Here</secondary-button>
                    <next-section v-else></next-section>
                    <div class="vertical-arrow">
                        <div class="vertical-line"></div>
                        <svg class="svg-arrow-bottom"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1">
                            <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                                id="path-1">
                            </path>
                        </svg>
                    </div>

                    <div class="section-container geo-routing-container" id="geo-routing">
                        <div class="section-icon">
                            <svg class="svg-greeting"
                                width="30px"
                                height="30px"
                                viewBox="0 0 30 30"
                                version="1.1">
                                <path fill="#ffffff" id="Shape"
                                    d="m14.60156,0c3.80006,0 7.25423,1.45833 9.84967,3.8393l2.9267,-2.9267l0,6.38818c0,1.00842 -0.81676,1.8252 -1.8252,1.8252l-6.38818,0l3.99354,-3.99353c-2.26599,-2.05243 -5.26571,-3.30725 -8.55653,-3.30725c-7.04524,0 -12.77637,5.73111 -12.77637,12.77637c0,7.04526 5.73113,12.77637 12.77637,12.77637c7.04524,0 12.77637,-5.73111 12.77637,-12.77637c0,-0.93997 -0.1095,-1.8544 -0.30298,-2.73779l1.86263,0c0.16883,0.88797 0.26555,1.80147 0.26555,2.73779c0,8.06462 -6.53692,14.60156 -14.60156,14.60156c-8.06464,0 -14.60156,-6.53694 -14.60156,-14.60156c0,-8.06463 6.53693,-14.60156 14.60156,-14.60156z"/>
                                <polygon fill="#ffffff"
                                        points="21.810165192324348,20.611935725566582 14.601562779396772,13.40241055055867 14.601562779396772,7.300780922240392 12.776367431972176,7.300780922240392 12.776367431972176,14.548628771061885 12.773635607454707,14.551371814571212 20.32264841100732,22.100376203879932 "
                                        id="Shape"/>
                            </svg>
                        </div>
                        <div class="container-title">
                            Geo-Routing
                            <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <polygon
                                        points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                            </svg>
                        </div>
                        <div class="container-subtitle">
                            Route callers to different destinations automatically by area code, or manually by zip code.
                        </div>
                        <div class="section-message-container">
                            <nav class="nav-header">
                                <p class="active">Area Code</p>
                                <p>ZIP Code</p>
                            </nav>
                            
                            <div v-for="(location,k) in callflow.workflow.items[5].georouting.items" :key="k">
                                <div class="seconds">
                                    <p class="bold">Location {{k+1}}:</p>
                                    <p>If the caller's area code matches the following area codes:</p>
                                    <img @click="callflow.workflow.items[5].georouting.items.splice(k,1)" 
                                        class="check-icon"
                                        src="@/assets/Icon/close-normal.svg"
                                        alt="">
                                </div>
                                <div class="message">
                                    <div class="message-line"></div>
                                    <div class="message-cycle">
                                        <svg class="svg"
                                            width="30px"
                                            height="30px"
                                            viewBox="0 0 30 30"
                                            version="1.1">
                                            <path d="M31.25,13.9172814 C31.25,6.672798 24.4410278,0.75 16,0.75 C7.55897218,0.75 0.75,6.672798 0.75,13.9172814 C0.75,16.7162869 1.76166664,19.3779082 3.62330006,21.6046209 C4.40339287,22.5373107 4.78726221,23.7348292 4.6477264,24.9033811 C4.47765319,26.3299681 3.62497752,27.642961 2.02076721,28.763238 C1.82947102,28.8969925 1.92060972,29.2140316 2.16084198,29.2284006 C4.86329986,29.3902683 8.13496536,28.6928887 11.96316,26.7828564 L12.1965639,26.6664023 L12.451859,26.719913 C13.6050082,26.9616168 14.7917672,27.0845627 16,27.0845627 C24.4410278,27.0845627 31.25,21.1617647 31.25,13.9172814 Z"
                                                id="Shape" stroke="#23C0FF" stroke-width="1.5" fill-rule="nonzero"></path>
                                            <path d="M8.75,10 L21.25,10 C21.6642136,10 22,10.3357864 22,10.75 C22,11.1642136 21.6642136,11.5 21.25,11.5 L8.75,11.5 C8.33578644,11.5 8,11.1642136 8,10.75 C8,10.3357864 8.33578644,10 8.75,10 Z M8.75,13.5 L23.25,13.5 C23.6642136,13.5 24,13.8357864 24,14.25 C24,14.6642136 23.6642136,15 23.25,15 L8.75,15 C8.33578644,15 8,14.6642136 8,14.25 C8,13.8357864 8.33578644,13.5 8.75,13.5 Z M8.75,17 L19.25,17 C19.6642136,17 20,17.3357864 20,17.75 C20,18.1642136 19.6642136,18.5 19.25,18.5 L8.75,18.5 C8.33578644,18.5 8,18.1642136 8,17.75 C8,17.3357864 8.33578644,17 8.75,17 Z"
                                                id="Combined-Shape" fill="#23C0FF"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="add-item">
                                    <div class="item" v-for="(code, i) in location.codes" :key="i">
                                        <primary-input
                                                class="menu-input"
                                                type="text"
                                                v-model="location.codes[i]"
                                                name=" "/>
                                        <img @click="location.codes.splice(i,1)"
                                            class="check-icon"
                                            src="@/assets/Icon/close-normal.svg"
                                            alt="">
                                    </div>
                                    <div class="add-button" @click="location.codes.push('')">
                                        <svg class="geo-add-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <polygon
                                                    points="24 10 14 10 14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14"></polygon>
                                        </svg>
                                        <p class="add-number">Add Area Code</p>
                                    </div>
                                </div>
                            </div>
                            <div class="primary-button" @click="addGeoLocation">
                                <primary-button>Add Location</primary-button>
                            </div>
                            <div class="seconds any-other-time active">
                                <p class="bold">Any other time</p>
                            </div>
                        </div>
                    </div>

                    <div class="to-next-step geo-routing-next-step">
                        <div class="horizontal-short-line"></div>
                        <div class="vertical-line"></div>
                        <div class="horizontal-long-line"></div>
                    </div>
                    <div class="vertical-line"></div>
                    <p class="insert-step-title">The caller's area code is different than any location above</p>
                    <div class="vertical-line"></div>
                    <secondary-button @click.native="InsertStep(5)" v-if="!insertStepbuttons[5]" class="insert-step">+ Insert Step Here</secondary-button>
                    <next-section v-else></next-section>
                    <div class="vertical-arrow">
                        <div class="vertical-line"></div>
                        <svg class="svg-arrow-bottom"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1">
                            <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                                id="path-1">
                            </path>
                        </svg>
                    </div>

                    <div class="section-container tag-container" id="tag">
                        <div class="section-icon">
                            <svg class="svg-greeting" width="30px" height="30px" viewBox="0 0 30 30" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g transform="translate(-349.000000, -5118.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                    <g transform="translate(320.000000, 305.000000)">
                                        <g transform="translate(0.000000, 4799.000000)">
                                            <g transform="translate(15.000000, 0.000000)">
                                                <g transform="translate(14.000000, 14.000000)">
                                                    <path d="M12.1875,1.875 C12.7209375,1.875 13.6846875,2.274375 14.0625,2.65125 L27.34875,15.9375 L15.9375,27.34875 L2.65125,14.0625 C2.274375,13.6846875 1.875,12.7209375 1.875,12.1875 L1.875,1.875 L12.1875,1.875 Z M12.1875,0 L1.875,0 C0.84375,0 0,0.84375 0,1.875 L0,12.1875 C0,13.21875 0.59625,14.65875 1.325625,15.388125 L14.611875,28.674375 C14.9765625,29.0390625 15.4575,29.2209375 15.9375,29.2209375 C16.4184375,29.2209375 16.8984375,29.0390625 17.263125,28.674375 L28.674375,17.263125 C29.40375,16.53375 29.40375,15.3403125 28.674375,14.611875 L15.388125,1.325625 C14.65875,0.59625 13.21875,1.45716772e-15 12.1875,1.45716772e-15 Z"
                                                        id="Shape"></path>
                                                    <path d="M8.4375,5.625 L6.5625,5.625 C6.045,5.625 5.625,6.045 5.625,6.5625 L5.625,8.4375 C5.625,8.955 6.045,9.375 6.5625,9.375 L8.4375,9.375 C8.955,9.375 9.375,8.955 9.375,8.4375 L9.375,6.5625 C9.375,6.045 8.955,5.625 8.4375,5.625 Z"
                                                        id="Shape"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="container-title">
                            Tag
                            <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <polygon
                                        points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                            </svg>
                        </div>
                        <div class="container-subtitle">
                            Add one or more tags to the call.
                        </div>
                        <div class="section">
                            <div class="section-title">apply tags</div>
                            <div class="tags-list">
                                <div v-for="(tag, k) in callflow.workflow.items[6].tag.items" :key="k"
                                    class="tag" 
                                    :class="tag == '#buzz' ? 'conversation' :  'missed-calls'">
                                    {{tag == '#buzz' ? 'Conversation' :  'Missed Calls'}}
                                    <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <polygon
                                                points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                                    </svg>
                                </div>

                                <!-- <div class="tag">
                                    Missed Calls
                                    <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <polygon
                                                points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                                    </svg>
                                </div> -->

                                <div class="add-button" @click="callflow.workflow.items[6].tag.items.push('#buzz')">
                                    <svg class="tag-add-icon" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <polygon
                                                points="24 10 14 10 14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14"></polygon>
                                    </svg>
                                    <p class="add-tag">Add Tag</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vertical-line"></div>
                    <secondary-button @click.native="InsertStep(6)" v-if="!insertStepbuttons[6]" class="insert-step">+ Insert Step Here</secondary-button>
                    <next-section v-else></next-section>
                    <div class="vertical-arrow">
                        <div class="vertical-line"></div>
                        <svg class="svg-arrow-bottom"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1">
                            <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                                id="path-1">
                            </path>
                        </svg>
                    </div>

                    <div class="section-container hang-up-container" id="hang-up">
                        <div class="section-icon">
                            <svg class="svg-greeting"
                                width="30px"
                                height="40px"
                                viewBox="0 0 30 30"
                                version="1.1">
                                <g transform="scale(0.8) translate(19.500000, 15.238427) rotate(135.000000) translate(-14.500000, -15.238427)">
                                    <path d="M29.2451105,23.7992835 C29.1981628,23.6011294 29.0633839,23.4298657 28.8099513,23.2726268 L22.8570784,19.7541005 L22.8225214,19.7541005 L22.6442756,19.6470397 C22.562494,19.5979187 22.4073607,19.5634229 22.1730096,19.5634229 C21.8488343,19.5634229 21.5816246,19.6652845 21.3741839,19.8473614 L19.5593808,21.6952191 C19.421692,21.8329976 19.256152,21.9221758 19.0595866,21.9878473 C18.8928369,22.0434364 18.7604384,22.0740118 18.6159084,22.0740118 L18.4685996,22.0594029 L18.0722351,21.9800056 C17.7250135,21.9107068 17.2885701,21.7348411 16.7344979,21.4517262 C16.1968864,21.1770223 15.5463255,20.7597406 14.7759223,20.198179 C13.9970344,19.6302245 13.1201247,18.8459756 12.1524515,17.855788 C11.1504608,16.8749409 10.3718401,16.0025636 9.81476578,15.2333 C9.2634134,14.4719378 8.85103508,13.8195093 8.58122706,13.2793603 C8.25373294,12.6473528 8.0383562,12.0726405 7.93870381,11.5491244 L7.92547453,11.4088786 C7.92547453,11.2538132 7.9564076,11.099047 8.01155408,10.9334997 C8.0768944,10.737351 8.16611486,10.5715479 8.30376623,10.4338068 L9.85995263,8.87660609 C10.0308465,8.70560088 10.1412521,8.49764307 10.1964242,8.2354045 C10.2442413,8.0081253 10.2178116,7.82299649 10.1079925,7.62706535 L6.74049447,1.22873965 C6.64027229,1.07114499 6.52190637,0.942251072 6.38327033,0.838206264 C6.30279464,0.777810157 6.2175657,0.75 6.10300313,0.75 C5.92647753,0.75 5.77655505,0.815633837 5.61722097,0.975071769 L1.36468776,5.22891011 C1.22890785,5.35119167 1.10604867,5.52113711 0.998379079,5.74431235 C0.889404698,5.97019213 0.819171257,6.18575794 0.78539652,6.39184375 C0.781702971,6.49299005 0.771703227,6.68496357 0.754139916,7.00130922 C0.736422125,7.32043733 0.774826787,7.79600478 0.873067276,8.41532326 C0.97228098,9.04077699 1.1642697,9.79912117 1.44972762,10.6866578 C1.73206484,11.5644917 2.16004443,12.5535361 2.73426216,13.6513211 C3.30864219,14.7495126 4.0724172,15.9527385 5.02568146,17.2591979 C5.9742604,18.5591348 7.17588034,19.9273739 8.63736291,21.3690042 C10.465672,23.2193456 12.1832552,24.6688686 13.7864503,25.7176765 C15.4020562,26.7746543 16.8389429,27.5631564 18.0937091,28.0836815 C19.3445163,28.6025885 20.3902445,28.9245882 21.2225877,29.0520188 C22.087423,29.1844238 22.7074031,29.25 23.0624147,29.25 C23.2080907,29.25 23.3224207,29.2455662 23.4004851,29.2377816 C23.4889536,29.2289333 23.5471889,29.2234853 23.5923818,29.2206056 C23.7997584,29.1872431 24.0168747,29.1167242 24.2449028,29.0065315 C24.4674044,28.8991598 24.6371409,28.7762523 24.7886528,28.6095777 L29.0104966,24.4169099 C29.2007239,24.2265037 29.2702307,24.0402315 29.2451105,23.7992835 Z M9.43420582,11.408767 C9.43441065,11.4082869 9.43456427,11.4078858 9.4346717,11.4075633 C9.43404097,11.4094567 9.43345307,11.4112309 9.43290513,11.4128812 Z M18.5793266,20.566796 C18.5809879,20.5662378 18.5827995,20.5656377 18.5847344,20.5649927 C18.5841234,20.5651969 18.5832137,20.5655763 18.5819949,20.5661751 Z"
                                        id="Shape" stroke="#FFFFFF" stroke-width="1.5" fill-rule="nonzero"></path>
                                    <path d="M27.4393398,1.5 L21,1.5 L21,0 L30,0 L30,9 L28.5,9 L28.5,2.56066017 L17.802408,13.2582521 C17.5095148,13.5511454 17.0346411,13.5511454 16.7417479,13.2582521 C16.4488546,12.9653589 16.4488546,12.4904852 16.7417479,12.197592 L27.4393398,1.5 Z"
                                        id="Combined-Shape" fill="#FFFFFF"></path>
                                </g>
                            </svg>
                        </div>
                        <div class="container-title">
                            Hang up
                            <svg class="svg-close" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <polygon
                                        points="15.6147692 1.69046154 14.3095385 0.385230769 8 6.69476923 1.69046154 0.385230769 0.385230769 1.69046154 6.69476923 8 0.385230769 14.3095385 1.69046154 15.6147692 8 9.30523077 14.3095385 15.6147692 15.6147692 14.3095385 9.30523077 8"></polygon>
                            </svg>
                        </div>
                        <div class="container-subtitle">
                            The call will be disconnected.
                        </div>
                    </div>

                    <div class="hang-up-next-step">
                        <div class="vertical-arrow">
                            <div class="vertical-line"></div>
                            <svg class="svg-arrow-bottom"
                                width="30px"
                                height="30px"
                                viewBox="0 0 30 30"
                                version="1.1">
                                <path d="M14.6619803,15.2477667 L18.909747,11 L20.3239606,12.4142136 L14.6671063,18.0710678 L14.6619803,18.0659418 L14.6568542,18.0710678 L9,12.4142136 L10.4142136,11 L14.6619803,15.2477667 Z"
                                    id="path-1">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <div class="section-container next-container">
                        <div class="section-icon">
                            <svg class="svg-plus" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                <polygon
                                        points="24 10 14 10 14 0 10 0 10 10 0 10 0 14 10 14 10 24 14 24 14 14 24 14"></polygon>
                            </svg>
                        </div>
                        <div class="container-title">
                            What would you like to happen next?
                        </div>
                        <div class="icons-wrapper">
                            <div class="row">
                                <div class="svg-container">
                                    <svg class="svg-greeting" width="32px" height="30px" viewBox="0 0 32 30" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M31.25,13.9172814 C31.25,6.672798 24.4410278,0.75 16,0.75 C7.55897218,0.75 0.75,6.672798 0.75,13.9172814 C0.75,16.7162869 1.76166664,19.3779082 3.62330006,21.6046209 C4.40339287,22.5373107 4.78726221,23.7348292 4.6477264,24.9033811 C4.47765319,26.3299681 3.62497752,27.642961 2.02076721,28.763238 C1.82947102,28.8969925 1.92060972,29.2140316 2.16084198,29.2284006 C4.86329986,29.3902683 8.13496536,28.6928887 11.96316,26.7828564 L12.1965639,26.6664023 L12.451859,26.719913 C13.6050082,26.9616168 14.7917672,27.0845627 16,27.0845627 C24.4410278,27.0845627 31.25,21.1617647 31.25,13.9172814 Z"></path>
                                        <path d="M8.75,10 L21.25,10 C21.6642136,10 22,10.3357864 22,10.75 C22,11.1642136 21.6642136,11.5 21.25,11.5 L8.75,11.5 C8.33578644,11.5 8,11.1642136 8,10.75 C8,10.3357864 8.33578644,10 8.75,10 Z M8.75,13.5 L23.25,13.5 C23.6642136,13.5 24,13.8357864 24,14.25 C24,14.6642136 23.6642136,15 23.25,15 L8.75,15 C8.33578644,15 8,14.6642136 8,14.25 C8,13.8357864 8.33578644,13.5 8.75,13.5 Z M8.75,17 L19.25,17 C19.6642136,17 20,17.3357864 20,17.75 C20,18.1642136 19.6642136,18.5 19.25,18.5 L8.75,18.5 C8.33578644,18.5 8,18.1642136 8,17.75 C8,17.3357864 8.33578644,17 8.75,17 Z"></path>
                                    </svg>
                                    <div class="svg-name">Greeting</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-dial" viewBox="0 0 36 32" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M29.2451105,23.7992835 C29.1981628,23.6011294 29.0633839,23.4298657 28.8099513,23.2726268 L22.8570784,19.7541005 L22.8225214,19.7541005 L22.6442756,19.6470397 C22.562494,19.5979187 22.4073607,19.5634229 22.1730096,19.5634229 C21.8488343,19.5634229 21.5816246,19.6652845 21.3741839,19.8473614 L19.5593808,21.6952191 C19.421692,21.8329976 19.256152,21.9221758 19.0595866,21.9878473 C18.8928369,22.0434364 18.7604384,22.0740118 18.6159084,22.0740118 L18.4685996,22.0594029 L18.0722351,21.9800056 C17.7250135,21.9107068 17.2885701,21.7348411 16.7344979,21.4517262 C16.1968864,21.1770223 15.5463255,20.7597406 14.7759223,20.198179 C13.9970344,19.6302245 13.1201247,18.8459756 12.1524515,17.855788 C11.1504608,16.8749409 10.3718401,16.0025636 9.81476578,15.2333 C9.2634134,14.4719378 8.85103508,13.8195093 8.58122706,13.2793603 C8.25373294,12.6473528 8.0383562,12.0726405 7.93870381,11.5491244 L7.92547453,11.4088786 C7.92547453,11.2538132 7.9564076,11.099047 8.01155408,10.9334997 C8.0768944,10.737351 8.16611486,10.5715479 8.30376623,10.4338068 L9.85995263,8.87660609 C10.0308465,8.70560088 10.1412521,8.49764307 10.1964242,8.2354045 C10.2442413,8.0081253 10.2178116,7.82299649 10.1079925,7.62706535 L6.74049447,1.22873965 C6.64027229,1.07114499 6.52190637,0.942251072 6.38327033,0.838206264 C6.30279464,0.777810157 6.2175657,0.75 6.10300313,0.75 C5.92647753,0.75 5.77655505,0.815633837 5.61722097,0.975071769 L1.36468776,5.22891011 C1.22890785,5.35119167 1.10604867,5.52113711 0.998379079,5.74431235 C0.889404698,5.97019213 0.819171257,6.18575794 0.78539652,6.39184375 C0.781702971,6.49299005 0.771703227,6.68496357 0.754139916,7.00130922 C0.736422125,7.32043733 0.774826787,7.79600478 0.873067276,8.41532326 C0.97228098,9.04077699 1.1642697,9.79912117 1.44972762,10.6866578 C1.73206484,11.5644917 2.16004443,12.5535361 2.73426216,13.6513211 C3.30864219,14.7495126 4.0724172,15.9527385 5.02568146,17.2591979 C5.9742604,18.5591348 7.17588034,19.9273739 8.63736291,21.3690042 C10.465672,23.2193456 12.1832552,24.6688686 13.7864503,25.7176765 C15.4020562,26.7746543 16.8389429,27.5631564 18.0937091,28.0836815 C19.3445163,28.6025885 20.3902445,28.9245882 21.2225877,29.0520188 C22.087423,29.1844238 22.7074031,29.25 23.0624147,29.25 C23.2080907,29.25 23.3224207,29.2455662 23.4004851,29.2377816 C23.4889536,29.2289333 23.5471889,29.2234853 23.5923818,29.2206056 C23.7997584,29.1872431 24.0168747,29.1167242 24.2449028,29.0065315 C24.4674044,28.8991598 24.6371409,28.7762523 24.7886528,28.6095777 L29.0104966,24.4169099 C29.2007239,24.2265037 29.2702307,24.0402315 29.2451105,23.7992835 Z M9.43420582,11.408767 C9.43441065,11.4082869 9.43456427,11.4078858 9.4346717,11.4075633 C9.43404097,11.4094567 9.43345307,11.4112309 9.43290513,11.4128812 Z M18.5793266,20.566796 C18.5809879,20.5662378 18.5827995,20.5656377 18.5847344,20.5649927 C18.5841234,20.5651969 18.5832137,20.5655763 18.5819949,20.5661751 Z"
                                            stroke="#70828B" stroke-width="1.5" fill-rule="nonzero"></path>
                                        <path d="M27.4393398,1.5 L21,1.5 L21,0 L30,0 L30,9 L28.5,9 L28.5,2.56066017 L17.802408,13.2582521 C17.5095148,13.5511454 17.0346411,13.5511454 16.7417479,13.2582521 C16.4488546,12.9653589 16.4488546,12.4904852 16.7417479,12.197592 L27.4393398,1.5 Z"
                                            fill="#70828B"></path>
                                    </svg>
                                    <div class="svg-name">Dial</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-simulcall" viewBox="0 0 36 32" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M10.774302,9.64814387 C10.7896146,9.69613141 10.8083497,9.72442409 10.8443603,9.77880535 C10.901167,9.85535364 10.901167,9.85535364 10.9375759,9.8924952 L10.7825473,9.66676897 C10.7779843,9.65650728 10.7771439,9.65461719 10.774302,9.64814387 Z M28.6572911,17.6552483 C26.0369929,16.9325014 23.47419,15.4462867 22.4580607,13.7782072 C21.7396658,12.605901 21.6536459,11.2526949 22.2387716,10.0806725 L12.7746783,10.0806725 C13.3596223,11.252826 13.2758089,12.6029534 12.5588735,13.777964 C11.5391524,15.4491736 8.97660313,16.9348505 6.35489123,17.6573521 L5.75470467,27.7223767 C5.7098468,28.4804747 6.16095191,29.0430016 6.70169492,29.0430016 L28.3115364,29.0430016 C28.8515818,29.0430016 29.3020886,28.4803647 29.2565741,27.7226419 L28.6572911,17.6552483 Z M22.2729751,10.0148696 C22.2899999,9.98386448 22.3091591,9.95090075 22.3387671,9.90082708 C22.3400077,9.89873115 22.3400077,9.89873115 22.3412409,9.89664851 C22.3633172,9.85942387 22.3633172,9.85942387 22.3808154,9.82964184 L22.8111536,10.0806725 L22.2712831,10.0806725 C22.2714347,10.0588881 22.2719991,10.0369562 22.2729751,10.0148696 Z M11.5333516,9.29671952 L12.1434867,9.03523302 C12.1465572,9.04239424 12.1465572,9.04239424 12.1472222,9.04392824 C12.1472496,9.04399121 12.1472496,9.04399121 12.1472592,9.04401318 C12.148063,9.0458514 12.148063,9.0458514 12.1532646,9.05756127 L11.467906,9.36216512 L11.5333516,9.29671952 Z M12.1324698,9.00960745 C12.1706382,9.07569306 12.1792648,9.12726127 12.2188901,9.36413341 L11.4688901,9.36413341 L12.1002643,8.95932892 C12.1111449,8.97629951 12.1218793,8.99305764 12.1324698,9.00960745 Z M17.5339311,5.98160897 L17.5071077,5.98177881 L17.4806694,5.98161141 C17.4557093,5.98167936 17.447742,5.98173752 17.4113067,5.98200348 L17.4036905,5.98206041 C17.3553287,5.98242121 17.3553287,5.98242121 17.3127392,5.98253144 L17.3127392,5.98300951 L16.9514762,5.98529695 L16.9514762,6.73253144 L18.0627392,6.73253144 L18.0627392,5.98529695 L17.7014762,5.98300951 L17.7014762,5.98253144 C17.6588848,5.9824212 17.6588848,5.9824212 17.6103809,5.98206025 L17.5937206,5.98193718 C17.5622263,5.98171899 17.5539901,5.98166193 17.5339311,5.98160897 Z M17.5071077,5.98177881 L17.3127392,5.98300951 L17.3127392,6.73253144 L17.7014762,6.73253144 L17.7014762,5.98300951 L17.5071077,5.98177881 Z M17.5071815,1.02613121 L18.0627392,1.01617011 L18.0627392,0.267687261 L16.9514762,0.267687261 L16.9514762,1.01615933 L17.5071815,1.02613121 Z"
                                            stroke="#70828B" stroke-width="1.5"></path>
                                        <path d="M13.9745216,24.3723346 L11.945216,24.3723346 C11.5712411,24.3723346 11.2681247,24.068234 11.2681247,23.6952433 C11.2681247,23.3222526 11.5712411,23.018152 11.945216,23.018152 L13.9745216,23.018152 C14.3475123,23.018152 14.6516129,23.3222526 14.6516129,23.6952433 C14.6516129,24.068234 14.3475123,24.3723346 13.9745216,24.3723346 Z M13.9745216,21.7919081 L11.945216,21.7919081 C11.5712411,21.7919081 11.2681247,21.4887917 11.2681247,21.115801 C11.2681247,20.7398578 11.5712411,20.4387097 11.945216,20.4387097 L13.9745216,20.4387097 C14.3475123,20.4387097 14.6516129,20.7398578 14.6516129,21.115801 C14.6516129,21.4887917 14.3475123,21.7919081 13.9745216,21.7919081 Z M13.9745216,19.2114817 L11.945216,19.2114817 C11.5712411,19.2114817 11.2681247,18.9083652 11.2681247,18.5343904 C11.2681247,18.1613997 11.5712411,17.8572991 11.945216,17.8572991 L13.9745216,17.8572991 C14.3475123,17.8572991 14.6516129,18.1613997 14.6516129,18.5343904 C14.6516129,18.9073811 14.3475123,19.2114817 13.9745216,19.2114817 Z M18.5222526,24.3723346 L16.4939311,24.3723346 C16.1199563,24.3723346 15.8168398,24.068234 15.8168398,23.6952433 C15.8168398,23.3222526 16.1209404,23.018152 16.4939311,23.018152 L18.5232367,23.018152 C18.8962274,23.018152 19.200328,23.3222526 19.200328,23.6952433 C19.1983598,24.068234 18.8952433,24.3723346 18.5222526,24.3723346 Z M18.5222526,21.7919081 L16.4939311,21.7919081 C16.1199563,21.7919081 15.8168398,21.4887917 15.8168398,21.115801 C15.8168398,20.7398578 16.1209404,20.4387097 16.4939311,20.4387097 L18.5232367,20.4387097 C18.8962274,20.4387097 19.200328,20.7398578 19.200328,21.115801 C19.1983598,21.4887917 18.8952433,21.7919081 18.5222526,21.7919081 Z M18.5222526,19.2114817 L16.4939311,19.2114817 C16.1199563,19.2114817 15.8168398,18.9083652 15.8168398,18.5343904 C15.8168398,18.1613997 16.1209404,17.8572991 16.4939311,17.8572991 L18.5232367,17.8572991 C18.8962274,17.8572991 19.200328,18.1613997 19.200328,18.5343904 C19.1983598,18.9073811 18.8952433,19.2114817 18.5222526,19.2114817 Z M23.0689995,24.3723346 L21.0396938,24.3723346 C20.6667031,24.3723346 20.3635867,24.068234 20.3635867,23.6952433 C20.3635867,23.3222526 20.6667031,23.018152 21.0396938,23.018152 L23.0689995,23.018152 C23.4439584,23.018152 23.7460908,23.3222526 23.7460908,23.6952433 C23.7460908,24.068234 23.4449426,24.3723346 23.0689995,24.3723346 Z M23.0689995,21.7919081 L21.0396938,21.7919081 C20.6667031,21.7919081 20.3635867,21.4887917 20.3635867,21.115801 C20.3635867,20.7398578 20.6667031,20.4387097 21.0396938,20.4387097 L23.0689995,20.4387097 C23.4439584,20.4387097 23.7460908,20.7398578 23.7460908,21.115801 C23.7460908,21.4887917 23.4449426,21.7919081 23.0689995,21.7919081 Z M23.0689995,19.2114817 L21.0396938,19.2114817 C20.6667031,19.2114817 20.3635867,18.9083652 20.3635867,18.5343904 C20.3635867,18.1613997 20.6667031,17.8572991 21.0396938,17.8572991 L23.0689995,17.8572991 C23.4439584,17.8572991 23.7460908,18.1613997 23.7460908,18.5343904 C23.7460908,18.9073811 23.4449426,19.2114817 23.0689995,19.2114817 Z"
                                            stroke="#70828B" stroke-width="1" fill="#70828B"></path>
                                        <g transform="translate(38.5, 10)  rotate(135)">
                                            <path d="M29.2451105,23.7992835 C29.1981628,23.6011294 29.0633839,23.4298657 28.8099513,23.2726268 L22.8570784,19.7541005 L22.8225214,19.7541005 L22.6442756,19.6470397 C22.562494,19.5979187 22.4073607,19.5634229 22.1730096,19.5634229 C21.8488343,19.5634229 21.5816246,19.6652845 21.3741839,19.8473614 L19.5593808,21.6952191 C19.421692,21.8329976 19.256152,21.9221758 19.0595866,21.9878473 C18.8928369,22.0434364 18.7604384,22.0740118 18.6159084,22.0740118 L18.4685996,22.0594029 L18.0722351,21.9800056 C17.7250135,21.9107068 17.2885701,21.7348411 16.7344979,21.4517262 C16.1968864,21.1770223 15.5463255,20.7597406 14.7759223,20.198179 C13.9970344,19.6302245 13.1201247,18.8459756 12.1524515,17.855788 C11.1504608,16.8749409 10.3718401,16.0025636 9.81476578,15.2333 C9.2634134,14.4719378 8.85103508,13.8195093 8.58122706,13.2793603 C8.25373294,12.6473528 8.0383562,12.0726405 7.93870381,11.5491244 L7.92547453,11.4088786 C7.92547453,11.2538132 7.9564076,11.099047 8.01155408,10.9334997 C8.0768944,10.737351 8.16611486,10.5715479 8.30376623,10.4338068 L9.85995263,8.87660609 C10.0308465,8.70560088 10.1412521,8.49764307 10.1964242,8.2354045 C10.2442413,8.0081253 10.2178116,7.82299649 10.1079925,7.62706535 L6.74049447,1.22873965 C6.64027229,1.07114499 6.52190637,0.942251072 6.38327033,0.838206264 C6.30279464,0.777810157 6.2175657,0.75 6.10300313,0.75 C5.92647753,0.75 5.77655505,0.815633837 5.61722097,0.975071769 L1.36468776,5.22891011 C1.22890785,5.35119167 1.10604867,5.52113711 0.998379079,5.74431235 C0.889404698,5.97019213 0.819171257,6.18575794 0.78539652,6.39184375 C0.781702971,6.49299005 0.771703227,6.68496357 0.754139916,7.00130922 C0.736422125,7.32043733 0.774826787,7.79600478 0.873067276,8.41532326 C0.97228098,9.04077699 1.1642697,9.79912117 1.44972762,10.6866578 C1.73206484,11.5644917 2.16004443,12.5535361 2.73426216,13.6513211 C3.30864219,14.7495126 4.0724172,15.9527385 5.02568146,17.2591979 C5.9742604,18.5591348 7.17588034,19.9273739 8.63736291,21.3690042 C10.465672,23.2193456 12.1832552,24.6688686 13.7864503,25.7176765 C15.4020562,26.7746543 16.8389429,27.5631564 18.0937091,28.0836815 C19.3445163,28.6025885 20.3902445,28.9245882 21.2225877,29.0520188 C22.087423,29.1844238 22.7074031,29.25 23.0624147,29.25 C23.2080907,29.25 23.3224207,29.2455662 23.4004851,29.2377816 C23.4889536,29.2289333 23.5471889,29.2234853 23.5923818,29.2206056 C23.7997584,29.1872431 24.0168747,29.1167242 24.2449028,29.0065315 C24.4674044,28.8991598 24.6371409,28.7762523 24.7886528,28.6095777 L29.0104966,24.4169099 C29.2007239,24.2265037 29.2702307,24.0402315 29.2451105,23.7992835 Z M9.43420582,11.408767 C9.43441065,11.4082869 9.43456427,11.4078858 9.4346717,11.4075633 C9.43404097,11.4094567 9.43345307,11.4112309 9.43290513,11.4128812 Z M18.5793266,20.566796 C18.5809879,20.5662378 18.5827995,20.5656377 18.5847344,20.5649927 C18.5841234,20.5651969 18.5832137,20.5655763 18.5819949,20.5661751 Z"
                                                stroke="#70828B" stroke-width="1.5" fill-rule="nonzero"></path>
                                        </g>
                                    </svg>
                                    <div class="svg-name">Simulcall</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-menu" viewBox="0 0 30 30" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <circle id="Oval" cx="4" cy="4" r="3.25"></circle>
                                        <circle id="Oval-Copy" cx="15" cy="4" r="3.25"></circle>
                                        <circle id="Oval-Copy-2" cx="26" cy="4" r="3.25"></circle>
                                        <circle id="Oval-Copy-5" cx="4" cy="15" r="3.25"></circle>
                                        <circle id="Oval-Copy-4" cx="15" cy="15" r="3.25"></circle>
                                        <circle id="Oval-Copy-3" cx="26" cy="15" r="3.25"></circle>
                                        <circle id="Oval-Copy-8" cx="4" cy="26" r="3.25"></circle>
                                        <circle id="Oval-Copy-7" cx="15" cy="26" r="3.25"></circle>
                                        <circle id="Oval-Copy-6" cx="26" cy="26" r="3.25"></circle>
                                    </svg>
                                    <div class="svg-name">Menu</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-schedule" viewBox="0 0 30 30" version="1.1">
                                        <path d="m14.60156,0c3.80006,0 7.25423,1.45833 9.84967,3.8393l2.9267,-2.9267l0,6.38818c0,1.00842 -0.81676,1.8252 -1.8252,1.8252l-6.38818,0l3.99354,-3.99353c-2.26599,-2.05243 -5.26571,-3.30725 -8.55653,-3.30725c-7.04524,0 -12.77637,5.73111 -12.77637,12.77637c0,7.04526 5.73113,12.77637 12.77637,12.77637c7.04524,0 12.77637,-5.73111 12.77637,-12.77637c0,-0.93997 -0.1095,-1.8544 -0.30298,-2.73779l1.86263,0c0.16883,0.88797 0.26555,1.80147 0.26555,2.73779c0,8.06462 -6.53692,14.60156 -14.60156,14.60156c-8.06464,0 -14.60156,-6.53694 -14.60156,-14.60156c0,-8.06463 6.53693,-14.60156 14.60156,-14.60156z"/>
                                        <polygon
                                                points="21.810165192324348,20.611935725566582 14.601562779396772,13.40241055055867 14.601562779396772,7.300780922240392 12.776367431972176,7.300780922240392 12.776367431972176,14.548628771061885 12.773635607454707,14.551371814571212 20.32264841100732,22.100376203879932 "/>
                                    </svg>
                                    <div class="svg-name">Schedule</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="svg-container">
                                    <svg class="svg-geo-routing" viewBox="0 0 24 30" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M11.5791966,0.757157102 L11.579066,0.757161696 C5.99631031,0.953047861 1.35729346,5.31254311 0.821699256,10.8700364 C0.715556989,11.9482184 0.768916644,13.0240644 0.977605563,14.1269668 C0.983207299,14.1661789 1.0028588,14.2668929 1.04694383,14.4441785 C1.21582276,15.1985044 1.47144869,15.9479532 1.81136224,16.6893392 C3.45782695,20.5901941 6.6318862,24.8779583 11.7949715,29.168635 C11.8980973,29.2551276 12.0540964,29.2551276 12.1618656,29.166179 C17.3232515,24.8820247 20.4951117,20.5977585 22.1601566,16.6573671 C22.4892585,15.9529736 22.7412116,15.2115117 22.9141861,14.4332406 C22.9529659,14.265195 22.9767448,14.1490979 22.9883053,14.0857051 C23.1223384,13.386402 23.1900615,12.6774707 23.1900615,11.9584426 C23.1900615,5.61563252 17.936726,0.532976588 11.5791966,0.757157102 Z M11.7683775,16.2499917 C9.55892582,16.2499917 7.76837747,14.4594434 7.76837747,12.2499917 C7.76837747,10.0405401 9.55892582,8.24999174 11.7683775,8.24999174 C13.9778291,8.24999174 15.7683775,10.0405401 15.7683775,12.2499917 C15.7683775,14.4594434 13.9778291,16.2499917 11.7683775,16.2499917 Z"
                                            id="Shape"></path>
                                    </svg>
                                    <div class="svg-name">Geo Routing</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-tag" viewBox="0 0 30 30" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <path d="M12.1875,1.875 C12.7209375,1.875 13.6846875,2.274375 14.0625,2.65125 L27.34875,15.9375 L15.9375,27.34875 L2.65125,14.0625 C2.274375,13.6846875 1.875,12.7209375 1.875,12.1875 L1.875,1.875 L12.1875,1.875 Z M12.1875,0 L1.875,0 C0.84375,0 0,0.84375 0,1.875 L0,12.1875 C0,13.21875 0.59625,14.65875 1.325625,15.388125 L14.611875,28.674375 C14.9765625,29.0390625 15.4575,29.2209375 15.9375,29.2209375 C16.4184375,29.2209375 16.8984375,29.0390625 17.263125,28.674375 L28.674375,17.263125 C29.40375,16.53375 29.40375,15.3403125 28.674375,14.611875 L15.388125,1.325625 C14.65875,0.59625 13.21875,1.45716772e-15 12.1875,1.45716772e-15 Z"
                                            id="Shape"></path>
                                        <path d="M8.4375,5.625 L6.5625,5.625 C6.045,5.625 5.625,6.045 5.625,6.5625 L5.625,8.4375 C5.625,8.955 6.045,9.375 6.5625,9.375 L8.4375,9.375 C8.955,9.375 9.375,8.955 9.375,8.4375 L9.375,6.5625 C9.375,6.045 8.955,5.625 8.4375,5.625 Z"
                                            id="Shape"></path>
                                    </svg>
                                    <div class="svg-name">Tag</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-voicemail" viewBox="0 0 70 50" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <rect x="1.5" y="1.5" width="67" height="47" rx="8"></rect>
                                        <path d="M44.5909091,17 C39.9545455,17 36.0909091,20.8636364 36.0909091,25.5 C36.0909091,27.5090909 36.8636364,29.3636364 38.1,30.9090909 L30.9909091,30.9090909 C32.2272727,29.3636364 33,27.5090909 33,25.5 C33,20.8636364 29.1363636,17 24.5,17 C19.8636364,17 16,20.8636364 16,25.5 C16,30.1363636 19.8636364,34 24.5,34 L44.5909091,34 C49.2272727,34 53.0909091,30.1363636 53.0909091,25.5 C53.0909091,20.8636364 49.2272727,17 44.5909091,17 Z M24.5,30.9090909 C21.5636364,30.9090909 19.0909091,28.4363636 19.0909091,25.5 C19.0909091,22.5636364 21.5636364,20.0909091 24.5,20.0909091 C27.4363636,20.0909091 29.9090909,22.5636364 29.9090909,25.5 C29.9090909,28.4363636 27.4363636,30.9090909 24.5,30.9090909 Z M44.5909091,30.9090909 C41.6545455,30.9090909 39.1818182,28.4363636 39.1818182,25.5 C39.1818182,22.5636364 41.6545455,20.0909091 44.5909091,20.0909091 C47.5272727,20.0909091 50,22.5636364 50,25.5 C50,28.4363636 47.5272727,30.9090909 44.5909091,30.9090909 Z"
                                            fill-rule="nonzero"></path>
                                    </svg>
                                    <div class="svg-name">Voicemail</div>
                                </div>
                                <div class="svg-container">
                                    <svg class="svg-hang-up" viewBox="0 0 36 38" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g transform="translate(19.500000, 15.238427) rotate(135.000000) translate(-14.500000, -15.238427)">
                                            <path d="M29.2451105,23.7992835 C29.1981628,23.6011294 29.0633839,23.4298657 28.8099513,23.2726268 L22.8570784,19.7541005 L22.8225214,19.7541005 L22.6442756,19.6470397 C22.562494,19.5979187 22.4073607,19.5634229 22.1730096,19.5634229 C21.8488343,19.5634229 21.5816246,19.6652845 21.3741839,19.8473614 L19.5593808,21.6952191 C19.421692,21.8329976 19.256152,21.9221758 19.0595866,21.9878473 C18.8928369,22.0434364 18.7604384,22.0740118 18.6159084,22.0740118 L18.4685996,22.0594029 L18.0722351,21.9800056 C17.7250135,21.9107068 17.2885701,21.7348411 16.7344979,21.4517262 C16.1968864,21.1770223 15.5463255,20.7597406 14.7759223,20.198179 C13.9970344,19.6302245 13.1201247,18.8459756 12.1524515,17.855788 C11.1504608,16.8749409 10.3718401,16.0025636 9.81476578,15.2333 C9.2634134,14.4719378 8.85103508,13.8195093 8.58122706,13.2793603 C8.25373294,12.6473528 8.0383562,12.0726405 7.93870381,11.5491244 L7.92547453,11.4088786 C7.92547453,11.2538132 7.9564076,11.099047 8.01155408,10.9334997 C8.0768944,10.737351 8.16611486,10.5715479 8.30376623,10.4338068 L9.85995263,8.87660609 C10.0308465,8.70560088 10.1412521,8.49764307 10.1964242,8.2354045 C10.2442413,8.0081253 10.2178116,7.82299649 10.1079925,7.62706535 L6.74049447,1.22873965 C6.64027229,1.07114499 6.52190637,0.942251072 6.38327033,0.838206264 C6.30279464,0.777810157 6.2175657,0.75 6.10300313,0.75 C5.92647753,0.75 5.77655505,0.815633837 5.61722097,0.975071769 L1.36468776,5.22891011 C1.22890785,5.35119167 1.10604867,5.52113711 0.998379079,5.74431235 C0.889404698,5.97019213 0.819171257,6.18575794 0.78539652,6.39184375 C0.781702971,6.49299005 0.771703227,6.68496357 0.754139916,7.00130922 C0.736422125,7.32043733 0.774826787,7.79600478 0.873067276,8.41532326 C0.97228098,9.04077699 1.1642697,9.79912117 1.44972762,10.6866578 C1.73206484,11.5644917 2.16004443,12.5535361 2.73426216,13.6513211 C3.30864219,14.7495126 4.0724172,15.9527385 5.02568146,17.2591979 C5.9742604,18.5591348 7.17588034,19.9273739 8.63736291,21.3690042 C10.465672,23.2193456 12.1832552,24.6688686 13.7864503,25.7176765 C15.4020562,26.7746543 16.8389429,27.5631564 18.0937091,28.0836815 C19.3445163,28.6025885 20.3902445,28.9245882 21.2225877,29.0520188 C22.087423,29.1844238 22.7074031,29.25 23.0624147,29.25 C23.2080907,29.25 23.3224207,29.2455662 23.4004851,29.2377816 C23.4889536,29.2289333 23.5471889,29.2234853 23.5923818,29.2206056 C23.7997584,29.1872431 24.0168747,29.1167242 24.2449028,29.0065315 C24.4674044,28.8991598 24.6371409,28.7762523 24.7886528,28.6095777 L29.0104966,24.4169099 C29.2007239,24.2265037 29.2702307,24.0402315 29.2451105,23.7992835 Z M9.43420582,11.408767 C9.43441065,11.4082869 9.43456427,11.4078858 9.4346717,11.4075633 C9.43404097,11.4094567 9.43345307,11.4112309 9.43290513,11.4128812 Z M18.5793266,20.566796 C18.5809879,20.5662378 18.5827995,20.5656377 18.5847344,20.5649927 C18.5841234,20.5651969 18.5832137,20.5655763 18.5819949,20.5661751 Z"
                                                stroke="#D2305B" stroke-width="1.5" fill="#FFFFFF"></path>
                                            <path d="M27.4393398,1.5 L21,1.5 L21,0 L30,0 L30,9 L28.5,9 L28.5,2.56066017 L17.802408,13.2582521 C17.5095148,13.5511454 17.0346411,13.5511454 16.7417479,13.2582521 C16.4488546,12.9653589 16.4488546,12.4904852 16.7417479,12.197592 L27.4393398,1.5 Z"
                                                stroke="#D2305B" stroke-width="0.5" fill="#D2305B"></path>
                                        </g>
                                    </svg>
                                    <div class="svg-name red">Hang Up</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    components: {
      PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
      PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
      SecondaryButton: () => import('@/components/Buttons/SecondaryButton.vue'),
      PrimaryButton: () => import('@/components/Buttons/PrimaryButton.vue'),
      TextArea: () => import("@/components/Inputs/TextArea"),
      AppDropzone: () => import("@/components/Dropzone"),
      NextSection: () => import("./NextSection.vue"),
    },
    data: () => ({
      callflowError: null,
      insertStepbuttons: [false,false,false,false,false,false,false],
      dialTimeout: ["20","30","45","60"],
      hours: [],
      seconds: [],
      isGreetingMessage: true,
      isMenuMessage: true,
      menuTypes: ['Forward to sales','Forward to support'],
      weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Saturday', 'Sunday'],
      callflow: {
        call_workflow_name: '',
        workflow: {
            items: [
                {
                    action: "record",
                    record: {
                        notify_the_caller: true
                    },
                },
                {   
                    action: "dial",
                    dial: {
                        prevent_answering: true,
                        destination: null,
                        timeout: "20"
                    },
                },
                {
                    action: "simulcall",
                    simulcall: {
                        prevent_answering: true,
                        ring_at_once: true,
                        destinations: [''],
                        timeout: "20"
                    },
                },
                {
                    action: "menu",
                    menu: {
                        items: [
                            {
                                name: '1',
                                pressed: "1",
                                on_press: {
										items:[	
											{
												action: "say", 
												say: {
														message: "you press one"
													}
											}
										]
								}
                            },
                            {
                                name: '2',
                                pressed: "2",
                                on_press: {
										items:[	
											{
												action: "say", 
												say: {
														message: "you press two"
													}
											}
										]
								}
                            }
                        ]
                    },
                },
                {
                    action: "schedule",
                    schedule: {
                        items: [
                            {
                                times: [
                                    {
                                        type: 'Between',
                                        start: '00:00',
                                        startHour: '00',
                                        startSecond: '00',
                                        stop: '23:59',
                                        stopHour: '00',
                                        stopSecond: '00',
                                        weekdays: [
                                            1
                                        ],
                                    },
                                    {
                                        type: 'All day',
                                        start: '00:00',
                                        startHour: '00',
                                        startSecond: '00',
                                        stop: '23:59',
                                        stopHour: '00',
                                        stopSecond: '00',
                                        weekdays: [
                                            1
                                        ],
                                    }
                                ],
                                name: 'Schedule Branch A'
                            },
                            {
                                times: [
                                    {
                                        type: 'Between',
                                        start: '00:00',
                                        startHour: '00',
                                        startSecond: '00',
                                        stop: '23:59',
                                        stopHour: '00',
                                        stopSecond: '00',
                                        weekdays: [
                                            1
                                        ],
                                    },
                                    {
                                        type: 'All day',
                                        start: '00:00',
                                        startHour: '00',
                                        startSecond: '00',
                                        stop: '23:59',
                                        stopHour: '00',
                                        stopSecond: '00',
                                        weekdays: [
                                            1
                                        ],
                                    }
                                ],
                                name: 'Schedule Branch B'
                            }
                        ]
                    },
                },
                {
                    action: "georouting",
                    georouting: {
                        items: [
                            {
                                name: 'Location 1',
                                codes: ['','']
                            },
                            {
                                name: 'Location 2',
                                codes: ['', '', '']
                            }
                        ]
                    },
                },
                {
                    action: "tag",
                    tag: {
                        items: ['#buzz','#test']
                    },
                },
                {
                    action: "say",
                    say: {
                        message: 'This call will be recorded for quality assurance.'
                    },
                },
                // {
                //     action: "stop",  //play
                //     play: {
                //         message_url: null
                //     },
                // },
            ]
        }
      },
      test: {},
    }),
    watch: {
        'callflow.workflow.items': function(callflow) {
            console.log(callflow)
        }
    },
    created() {
        for(var i = 0; i <= 23; i++) {
            this.hours.push(i<10 ? '0'+ i : i)
        }
        for(var i = 0; i <= 59; i++) {
            this.seconds.push(i<10 ? '0'+ i : i)
        }
    },
    computed: {
        
    },
    methods: {
      InsertStep(index) {
        this.insertStepbuttons[index] = !this.insertStepbuttons[index];
        this.insertStepbuttons = [...this.insertStepbuttons]
      },
      getAction(action) {
        return this.callflow.workflow.items.find(item => item.action === action);
      },
      fileAdded(file) {
        console.log(file);
        if (file.accepted) {
            this.file = file;
            this.enabledUpload = false;
        }
      },
      changePressed(menu,k){
          console.log("menu", menu)
          menu.map((item, index )=> {
              if(index !== k) {
                  item.pressed = item.pressed == '2' ? '1' : '2'
                  console.log("item",item)
              }
          })
      },
      updateStart(time) {
        time.start = time.startHour + ':' + time.startSecond;
        console.log('time.start',time.start)
      },
      updateStop(time) {
        time.stop = time.stopHour + ':' + time.stopSecond;
      },
      updateTime(time) {
          if(time.type == 'All day') {
              time.start = '00:00';
              time.stop = '23:59'
          }
      },
      addScheduleTime(k) {
        this.callflow.workflow.items[4].schedule.items[k].times.push(
            {
                type: 'Between',
                start: '00:00',
                startHour: '00',
                startSecond: '00',
                stop: '23:59',
                stopHour: '00',
                stopSecond: '00',
                weekdays: [
                    1
                ],
            }
        )
      },
      addScheduleBranch() {
          this.callflow.workflow.items[4].schedule.items.push(
            {
                times: [
                    {
                        type: 'Between',
                        start: '00:00',
                        startHour: '00',
                        startSecond: '00',
                        stop: '23:59',
                        stopHour: '00',
                        stopSecond: '00',
                        weekdays: [
                            1
                        ],
                    }
                ],
                name: null
            }
          ) 
      },
      addGeoLocation() {
          let name = this.callflow.workflow.items[5].georouting.items.length + 1
          this.callflow.workflow.items[5].georouting.items.push(
            {
                name: 'Location ' + name,
                codes: ['']
            }
          ) 
      },
      isNotify() {
        this.callflow.workflow.items[0].record.notify_the_caller = !this.callflow.workflow.items[0].record.notify_the_caller;
      },
      isDialPreventAnswering() {
          this.callflow.workflow.items[1].dial.prevent_answering = !this.callflow.workflow.items[1].dial.prevent_answering; 
      },
      addcallflow() {
        this.$validator.validate().then(result => {
          if (result) {
            this.callflow.workflow.items.map(item => {
                if(item.action == 'schedule') {
                    item.schedule.items.map(schedule => {
                        console.log("schedule", schedule);
                        schedule.times.map(time => {
                            delete time.type;
                            delete time.startHour;
                            delete time.startSecond;
                            delete time.stopHour;
                            delete time.stopSecond;
                        })
                    })
                }
            })
            console.log("this.callflow", this.callflow);
            this.$store
              .dispatch("NewCallFlow", this.callflow)
              .then(() => {
                this.$snotify.success("callflow have been added.", {
                  timeout: 6000
                });
                this.$router.push({name: "system-admin-dids-all-dids"});
              })
              .catch(err => {
                if (err.errors) {
                  this.callflowError = err.errors[0].callflow
                    ? err.errors[0].callflow
                    : null;
                  setTimeout(() => {
                    this.callflowError = null;
                  }, 6000);
                } else {
                    console.log("err.response.data.errors", err.response.data.errors)
                  this.$snotify.error(err.response.data.errors, {
                    timeout: 6000
                  });
                }
              });
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
    .container {
        font-family: "Helvetica Neue";
        padding: 0 20px;
        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;
            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;
                p {
                    margin-bottom: 0;
                }
            }
            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;
                .primary-button {
                    height: 40px;
                    width: 110px;
                }
                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 20px;
                }
            }
        }
        .add-container {
            flex-direction: column;
            align-items: center;
            height: 135px;
            background-color: #FFFFFF;
            padding-top: 15px;
            .container-title {
                height: 30px;
                width: 432px;
                color: #000000;
                font-size: 18px;
                font-weight: 500;
                line-height: 30px;
                padding: 15px 0 15px 15px;
            }
            .col-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-left: 15px;
                margin-top: 15px;
                .col {
                    width: 100%;
                    margin-right: 15px;
                    padding: 0;
                    .input {
                        padding-bottom: 15px;
                    }
                    .field {
                        p.pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                        }
                    }
                   p.pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                        }
                }
            }
        }
        .callflow-container {
            width: 100%;
            margin-top: 30px;
            .cycle-wrapper {
                display: flex;
                margin-right: 15px;
                .cycle-home {
                    height: 60px;
                    width: 60px;
                    border-radius: 30px;
                    background-color: #51A3F3;
                    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                    text-align: center;
                    padding: 15px 0;
                    .svg-home {
                        height: 30px;
                        width: 30px;
                        fill: #FFFFFF;
                    }
                }
                .header {
                    color: #161D29;
                    font-family: ""Helvetica Neue"";
                    font-size: 30px;
                    font-weight: 300;
                    line-height: 48px;
                    text-align: center;
                    margin-left: 14px;
                    padding: 6px 0;
                }
                .cycle-plass {
                    box-sizing: border-box;
                    height: 41px;
                    width: 41px;
                    border: 1px solid #24E2B8;
                    border-radius: 30px;
                    background-color: #FFFFFF;
                    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                    margin-left: 9.5px;
                    .svg {
                        fill: #24E2B8;
                        margin: 5.5px
                    }
                }
            }
            .start-content {
                .svg-close {
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                    polygon {
                        fill: #A6B6BE;
                    }
                }
                .vertical-arrow {
                    margin-bottom: 20px;
                    .vertical-line {
                        border-left: 2px solid #BDBFD8;
                        height: 30px;
                        margin-left: 41px;
                    }
                    .svg-arrow-bottom {
                        margin-left: 27px;
                        padding: 0;
                        z-index: 10;
                        margin-top: -25px;
                        fill: #BDBFD8;
                    }
                }
                .vertical-line {
                    border-left: 2px solid #BDBFD8;
                    height: 30px;
                    margin-left: 41px;
                    // width: 2px;
                    // background-color: #BDBFD8;
                }
                .message {
                    margin-left: 669px;
                    .message-line {
                        height: 2px;
                        width: 40px;
                        background-color: #92E0FF;
                        margin-top: -35px;
                    }
                    .message-cycle {
                        height: 50px;
                        width: 50px;
                        border: 2px solid #92E0FF;
                        background-color: #F8F9FE;
                        border-radius: 50%;
                        margin-top: -25px;
                        margin-left: 40px;
                        fill: #F8F9FE;
                        padding: 10px 11px 11px 11px;
                        svg {
                            width: 23px;
                            height: 20px;
                        }
                    }
                }
                .warning {
                    margin-left: 700px;
                    .warning-line {
                        height: 2px;
                        width: 40px;
                        background-color: #FFB9BF;
                        margin-top: -80px;
                    }
                    .warning-cycle {
                        height: 50px;
                        width: 50px;
                        border: 2px solid #FFB9BF;
                        background-color: #F4F6F7;
                        border-radius: 50%;
                        margin-top: -25px;
                        margin-left: 40px;
                        padding: 8.6px 17.34px 19px 15.33px;;
                        .warning-icon {
                            height: 14.94px;	
                            width: 15.33px;
                        }
                    }
                }
                .to-next-step {
                    .horizontal-short-line {
                        margin-left: 700px;
                        height: 2px;
                        width: 123px;
                        background-color: #BDBFD8;
                        margin-top: -100px;
                    }
                    .vertical-line {
                        height: 214px;
                        width: 2px;
                        background-color: #BDBFD8;
                        margin-left: 821px;
                    }
                    .horizontal-long-line {
                        height: 2px;
                        width: 782px;
                        background-color: #BDBFD8;
                        margin-left: 41px;
                    }
                }
                .schedule-next-step {
                    .horizontal-short-line {
                        margin-top: -285px;
                    }
                    .vertical-line {
                        height: 357px;
                    }
                }
                .menu-next-step {
                    .horizontal-short-line {
                        margin-top: -150px;
                    }
                    .warning {
                        .warning-line {
                            margin-top: -105px;
                        }
                    }
                }
                .geo-routing-next-step {
                    .horizontal-short-line {
                        width: 120px;
                        margin-top: -75px;
                    }
                    .vertical-line {
                        height: 108px;
                        margin-left: 818px;
                    }
                    .horizontal-long-line {
                        width: 780px;
                    }
                }
                .hang-up-next-step {
                    .vertical-line {
                        height: 60px;
                    }
                }
                .line {
                    display: inline-flex;
                    height: 30px;
                    margin: 15px 0 15px 28px;
                    .svg-microphone {
                        width: 20.5px;
                        height: 24px;
                        fill: #4D545E;
                        margin: 3px 5.5px 3px 0;
                    }
                    .svg-record {
                        margin-left: 35px;
                    }
                    .record-text {
                        color: #4D545E;
                        font-size: 16px;
                        font-weight: normal;
                        // line-height: 20px;
                        text-align: center;
                        margin: 5px 10px 5px 0px;
                    }
                    .radio-button {
                        height: 30px;
                        width: 50px;
                        border-radius: 15px;
                        background-color: #FFFFFF;
                        border: 1px solid #A6B6BE;
                        margin-left: 10px;
                        padding: 1px 23px 3px 3px;
                        cursor: pointer;
                        svg {
                            height: 24px;
                            width: 24px;
                            // box-shadow: 2px 2px 7px 0 rgba(77,84,94,0.24);
                        }
                    }
                    .radio-button.active {
                        padding: 2px 3px 3px 23px;
                        background-color: #24E2B8;
                        border: 0;
                    }
                    .radio-text {
                        color: #A6B6BE;
                        font-size: 16px;
                        line-height: 20px;
                        border-bottom: 1px dashed #A6B6BE;
                        margin: 2px 0 2px 15px;
                    }
                }
                .insert-step {
                    height: 36px;
                    width: 150px;
                    font-weight: normal;
                    border: 2px solid #A6B6BE;
                    color: #70828B;
                    border-radius: 6px;
                    margin: 5px 0 5px 35px;
                    font-size: 14px;
                    line-height: 20px;
                    text-align: center;
                    padding: 0;
                }
                .insert-step-title {
                    color: #70828B;
                    font-family: "Helvetica Neue";
                    font-size: 16px;
                    font-style: italic;
                    line-height: 36px;
                    margin: 5px 0 5px 35px;
                }
                .section-container {
                    background-color: white;
                    width: 700px;
                    border: 1px solid #D0D9E1;
                    border-radius: 6px;
                    padding: 0 30px 34px 30px;
                    margin-bottom: 15px;
                    //padding: 37px 30px 34px 30px;
                    .section-icon {
                        height: 54px;
                        width: 54px;
                        background-color: #55616E;
                        border-radius: 50%;
                        padding: 12px 9px;
                        margin-left: -15px;
                        margin-top: -27px;
                        .svg-greeting {
                            height: 30px;
                            width: 34px;
                            fill: #55616E;
                        }
                    }
                    .container-title {
                        display: block;
                        height: 30px;
                        color: #4D545E;
                        font-size: 21px;
                        font-weight: normal;
                        font-family: 'Proxima Nova';
                        line-height: 30px;
                        padding: 10px 0 15px 0;
                    }
                    .container-subtitle {
                        display: block;
                        height: 25px;
                        color: #70828B;
                        font-size: 14px;
                        font-weight: normal;
                        font-family: 'Helvetica Neue';
                        line-height: 25px;
                        padding: 15px 0 15px 0;
                    }
                    .section-message-container {
                        .seconds {
                            height: 70px;
                            width: 698px;
                            display: flex;
                            background-color: #F4F6F7;
                            border-left: 4px solid #51A3F3;
                            padding: 15px 30px 15px 29px;
                            margin-left: -30px;
                            p {
                                color: #31333B;
                                font-family: "Helvetica Neue";
                                font-size: 16px;
                                line-height: 40px;
                                height: 40px;
                            }
                            .seconds-select {
                                width: 150px;
                                margin: -5px 10px 0 4px;
                            }
                        }
                        .notActive {
                            margin-top: 5px;
                            background-color: #FFF1F2;
                            border-left: 4px solid #FF4F60;
                        }
                    }
                }
                .greeting-container {
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .section-message-container {
                        .nav-header {
                            height: 50px;
                            background-color: #fff;
                            display: flex;
                            margin-top: 22px;
                            p {
                                cursor: pointer;
                                width: auto;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 0;
                                color: #222A37;
                                font-family: 'Helvetica Neue';
                                font-size: 14px;
                                font-weight: normal;
                                line-height: 30px;
                                text-align: center;
                                padding: 0 15.5px;
                            }
                            .active {
                                color: #51a3f3;
                                border-bottom: 2px solid #51a3f3;
                            }
                        }
                        .col-wrapper {
                            .col {
                                padding-left: 0;
                                .text-area-title {
                                    font-size: 14px;
                                    line-height: 25px;
                                    font-family: 'Helvetica Neue';
                                    color: #70828B;
                                    font-weight: normal;
                                    margin: 0;
                                }
                                .text-area {
                                    height: 100px;
                                    pointer-events: none;
                                    opacity: 0.7;
                                }
                                .upload-container {
                                    width: 400px;
                                    .upload-photo {
                                        height: 100px;
                                    }
                                    .pimary-input-title {
                                        font-size: 14px;
                                        line-height: 25px;
                                        font-family: 'Helvetica Neue';
                                        color: #70828B;
                                        font-weight: normal;
                                        margin: 0;
                                    }
                                }
                            }
                        }
                        .preview-message-btn {
                            font-size: 14px;
                            line-height: 25px;
                            font-family: 'Helvetica Neue';
                            color: #51A3F3;
                            font-weight: normal;
                            margin: 0;
                        }
                    }
                }
                .dial-container {
                    height: 317px;
                    width: 700px;
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .section-message-container {
                        .destination-number {
                            display: flex;
                            margin-top: 15px;
                            padding: 0;
                            .primary-input-container {
                                display: inline-block;
                                //height: 40px;
                                //width: 172px;
                                margin-right: 20px;
                                .primary-input-title {
                                    text-transform: uppercase;
                                    color: #70828B;
                                    font-family: "Proxima Nova";
                                    font-size: 14px;
                                    font-weight: bold;
                                    letter-spacing: 1px;
                                    line-height: 25px;
                                    margin-bottom: 0;
                                }
                            }
                            .dial-input {
                                //width: fit-content;
                                margin-top: 25px;
                                width: 65%;
                            }
                        }
                        .voicemails {
                            height: 40px;
                            display: flex;
                            margin-top: 5px;
                            margin-bottom: 15px;
                            text-align: center;
                            .check-icon {
                                height: 20px;
                                width: 20px;
                                margin-right: 10px;
                                margin-top: 10px;
                            }
                            .active {
                                rect {
                                        fill: #24E2B8;
                                    }
                                    g rect {
                                        stroke: white;
                                        fill: white;
                                    }
                            }
                            .voicemails-title {
                                color: #31333B;
                                font-family: "Helvetica Neue";
                                font-size: 16px;
                                line-height: 40px;
                            }
                        }
                    }
                }
                .simulcall-container {
                    min-height: 552px;
                    width: 700px;
                    .section-icon {
                        padding: 12.27px 9.49px 12.2px 10.51px;
                        .svg-phone {
                            height: 29.53px;
                            //width: 34px;
                            fill: #55616E;
                        }
                        .svg-simulcall {
                            path {
                                fill: #55616E;
                                stroke: white;
                            }
                            g path {
                                fill: #55616E;
                                stroke: white;
                            }
                        }
                    }
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .container-subtitle {
                        height: 50px;
                    }
                    .section-message-container {
                        .ring-checkbox {
                            display: flex;
                            height: 40px;
                            margin-top: 15px;
                            div {
                                display: flex;
                                margin-right: 15px;
                                .check-icon {
                                    height: 16px;
                                    width: 16px;
                                    margin-right: 15px;
                                    margin-top: 12px;
                                }
                                p {
                                    font-weight: normal;
                                    color: #31333B;
                                    font-family: "Helvetica Neue";
                                    font-size: 16px;
                                    line-height: 40px;
                                    margin-bottom: 0;
                                }
                            }
                        }
                        .destination-number {
                            margin-top: 15px;
                            padding: 0;
                            .destination-number-row {
                                display: inline-block;
                                .primary-input-title {
                                    text-transform: uppercase;
                                    color: #70828B;
                                    font-family: "Proxima Nova";
                                    font-size: 14px;
                                    font-weight: bold;
                                    letter-spacing: 1px;
                                    line-height: 25px;
                                    margin-bottom: 0;
                                }
                                .primary-input-container {
                                    display: flex;
                                    width: 320px;
                                    .simulcall-input {
                                        margin-bottom: 15px;
                                    }
                                    .simpulcall-close {
                                        height: 15.23px;
                                        width: 15.23px;
                                        margin: 12.39px 0 12.38px 15.39px;
                                    }
                                }
                            }
                            
                            .dial-input {
                                width: 320px;
                                margin-top: 15px;
                            }
                            .add-number-container {
                                display: flex;
                                width: 17%;
                                .simulcall-add-icon {
                                    height: 16px;
                                    width: 16px;
                                    fill: #51A3F3;
                                    margin: 15px 5px 29px 0;
                                }
                                .add-number {
                                    color: #51A3F3;
                                    font-family: "Helvetica Neue";
                                    font-size: 14px;
                                    line-height: 25px;
                                    font-weight: normal;
                                    margin: 10px 0 25px 0;
                                }
                            }
                        }
                        .voicemails {
                            margin-top: 5px;
                            margin-bottom: 15px;
                            text-align: center;
                            div {
                                height: 40px;
                                display: flex;
                                .check-icon {
                                    height: 20px;
                                    width: 20px;
                                    margin-right: 10px;
                                    margin-top: 10px;
                                    rect {
                                        fill: #24E2B8;
                                    }
                                    g rect {
                                        stroke: white;
                                        fill: white;
                                    }
                                }
                                .voicemails-title {
                                    color: #31333B;
                                    font-family: "Helvetica Neue";
                                    font-size: 16px;
                                    line-height: 40px;
                                }
                            }
                        }
                    }
                }
                .menu-container {
                    min-height: 542px;
                    padding-bottom: 0;
                    .section-icon {
                        padding: 12px;
                    }
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .section-message-container {
                        .nav-header {
                            height: 50px;
                            background-color: #fff;
                            display: flex;
                            margin-top: 22px;
                            p {
                                cursor: pointer;
                                width: auto;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 0;
                                color: #222A37;
                                font-family: 'Helvetica Neue';
                                font-size: 14px;
                                font-weight: normal;
                                line-height: 30px;
                                text-align: center;
                                padding: 0 15.5px;
                            }
                            .active {
                                color: #51a3f3;
                                border-bottom: 2px solid #51a3f3;
                            }
                        }
                        .col-wrapper {
                            .col {
                                padding-left: 0;
                                .text-area-title {
                                    font-size: 14px;
                                    line-height: 25px;
                                    font-family: 'Helvetica Neue';
                                    color: #70828B;
                                    font-weight: normal;
                                    margin: 0;
                                }
                                .text-area {
                                    height: 100px;
                                    pointer-events: none;
                                    opacity: 0.7;
                                }
                                .upload-container {
                                    width: 400px;
                                    .upload-photo {
                                        height: 100px;
                                    }
                                    .pimary-input-title {
                                        font-size: 14px;
                                        line-height: 25px;
                                        font-family: 'Helvetica Neue';
                                        color: #70828B;
                                        font-weight: normal;
                                        margin: 0;
                                    }
                                }
                            }
                        }
                        .preview-message-btn {
                            font-size: 14px;
                            line-height: 25px;
                            font-family: 'Helvetica Neue';
                            color: #51A3F3;
                            font-weight: normal;
                            margin: 0;
                        }
                        .primary-select-title {
                            text-transform: uppercase;
                            color: #70828B;
                            font-family: "Proxima Nova";
                            font-size: 14px;
                            font-weight: bold;
                            letter-spacing: 1px;
                            line-height: 25px;
                            margin-bottom: 0;
                            margin-top: 30px;
                        }
                        .seconds {
                            margin-top: 5px;
                            .primary-select-container {
                                margin-top: -38px;
                                display: inline-block;
                                //height: 40px;
                                //width: 172px;
                            }
                            .menu-input {
                                margin-top: -5px;
                                width: 320px;
                                margin-right: 15.39px;
                            }
                        }
                        .notActive {
                            margin-top: 5px;
                        }
                        .add-number-container {
                            display: flex;
                            width: 17%;
                            .menu-add-icon {
                                height: 16px;
                                width: 16px;
                                fill: #51A3F3;
                                margin: 20px 5px 19px 0;
                            }
                            .add-number {
                                color: #51A3F3;
                                font-family: "Helvetica Neue";
                                font-size: 14px;
                                line-height: 25px;
                                font-weight: normal;
                                margin: 15px 0 15px 0;
                            }
                        }
                    }
                }
                .schedule-container {
                    min-height: 738px;
                    .section-icon {
                        padding: 12px;
                        .svg-schedule {
                            width: 30px;
                            height: 30px;
                        }
                    }
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .container-subtitle {
                        height: 80px;
                    }
                    .section-message-container {
                        .seconds {
                            margin-top: 15px;
                            .bold {
                                color: #31333B;
                                font-size: 16px;
                                font-weight: 600;
                            }
                            .check-icon {
                                margin-left: 156px;
                            }
                        }
                        .notActive {
                            margin-top: 15px;
                        }
                        .add-item {
                            .item {
                                margin-top: 15px;
                                display: flex;
                                .weekdays {
                                    width: 120px;
                                    margin-right: 10px;
                                }
                                .between {
                                    width: 110px;
                                    margin-right: 15px;
                                }
                                .between-container {
                                    display: flex;
                                }
                                .from {
                                    width: 75px;
                                }
                                .to {
                                    width: 60px;
                                }
                                span {
                                    color: #31333B;
                                    font-family: "Helvetica Neue";
                                    font-size: 16px;
                                    line-height: 40px;
                                    margin: 0 5px;
                                    width: 5px;
                                }
                                .ampersant {
                                    margin-left: 10px;
                                    margin-right: 9px;
                                    width: 11px;
                                    text-align: center;
                                }
                                .check-icon {
                                    margin-left: 32px;
                                }
                                .speace {
                                    width: 330px;
                                }
                            }
                            .add-button {
                                display: flex;
                                width: 17%;
                                .add-number {
                                    color: #51A3F3;
                                    font-family: "Helvetica Neue";
                                    font-size: 14px;
                                    line-height: 25px;
                                    font-weight: normal;
                                    margin: 10px 0 15px 0;
                                }
                                .schedule-add-icon {
                                    height: 16px;
                                    width: 16px;
                                    fill: #51A3F3;
                                    margin: 15px 5px 19px 0;
                                }
                            }
                        }
                        .primary-button {
                            width: 200px;
                            height: 40px;
                        }
                    }
                }
                .geo-routing-container {
                    min-height: 668px;
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .section-message-container {
                        .nav-header {
                            height: 50px;
                            background-color: #fff;
                            display: flex;
                            margin-top: 22px;
                            p {
                                cursor: pointer;
                                width: auto;
                                height: 30px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 0;
                                color: #222A37;
                                font-family: 'Helvetica Neue';
                                font-size: 14px;
                                font-weight: normal;
                                line-height: 30px;
                                text-align: center;
                                padding: 0 15.5px;
                            }
                            .active {
                                color: #51a3f3;
                                border-bottom: 2px solid #51a3f3;
                            }
                        }
                        .seconds {
                            .bold {
                                color: #31333B;
                                font-size: 16px;
                                font-weight: 600;
                            }
                            .check-icon {
                                margin-left: 125px;
                            }
                        }
                        .any-other-time {
                            margin-top: 30px;
                        }
                        .notActive {
                            margin-top: 15px;
                            background-color: #FFF1F2;
                            border-left: 4px solid #FF4F60;
                        }
                        .add-item {
                            .item {
                                width: 116px;
                                margin-top: 15px;
                                display: inline-flex;
                                margin-right: 15px;
                                .check-icon {
                                    margin-left: 10px;
                                }
                            }
                            .add-button {
                                display: flex;
                                width: 20%;
                                .add-number {
                                    color: #51A3F3;
                                    font-family: "Helvetica Neue";
                                    font-size: 14px;
                                    line-height: 25px;
                                    font-weight: normal;
                                    margin: 10px 0 15px 0;
                                }
                                .geo-add-icon {
                                    height: 16px;
                                    width: 16px;
                                    fill: #51A3F3;
                                    margin: 15px 5px 19px 0;
                                }
                            }
                        }
                        .primary-button {
                            width: 200px;
                            height: 40px;
                        }
                    }
                }
                .tag-container {
                    min-height: 215px;
                    width: 700px;
                    .container-title {
                        .svg-close {
                            float: right;
                        }
                    }
                    .section {
                        margin-top: 15px;
                        .section-title {
                            font-size: 14px;
                            font-family: 'Proxima Nova';
                            font-weight: bold;
                            line-height: 25px;
                            color: #70828B;
                            letter-spacing: 1px;
                            text-transform: uppercase;
                        }
                        .tags-list {
                            .tag {
                                display: inline-block;
                                font-size: 16px;
                                font-family: 'Helvetica Neue';
                                line-height: 20px;
                                color: #31333B;
                                padding: 8px 15px;
                                border-radius: 3px;
                                margin-right: 10px;
                                margin-bottom: 15px;
                                .svg-close {
                                    margin-left: 9px;
                                    stroke: #31333B;
                                    polygon {
                                        fill: #31333B;
                                    }
                                }
                            }
                            .tag.conversation {
                                background-color: #FEDE7F;
                            }
                            .tag.missed-calls {
                                background-color: #BBB4FF;
                            }
                            .add-button {
                                display: flex;
                                width: 17%;
                                margin-top: 15px;
                                .add-tag {
                                    color: #51A3F3;
                                    font-family: "Helvetica Neue";
                                    font-size: 14px;
                                    line-height: 25px;
                                    font-weight: normal;
                                    margin-bottom: 0;
                                }
                                .tag-add-icon {
                                    height: 16px;
                                    width: 16px;
                                    fill: #51A3F3;
                                    margin: 5px 5px 4px 0;
                                }
                            }
                        }
                    }
                }
                .hang-up-container {
                    height: 110px;
                    width: 700px;
                    .svg-greeting {
                        width: 30px;
                        height: 30px;
                    }
                    .container-title {
                        font-size: 21px;
                        font-family: 'Proxima Nova';
                        line-height: 30px;
                        color: #4D545E;
                        .svg-close {
                            float: right;
                        }
                    }
                    .container-subtitle {
                        font-size: 14px;
                        font-family: 'Helvetica Neue';
                        line-height: 25px;
                        color: #70828B;
                    }
                    .tags-list {
                        .tag {
                            display: inline-block;
                            font-size: 16px;
                            font-family: 'Helvetica Neue';
                            line-height: 20px;
                            color: #31333B;
                            padding: 8px 15px;
                            border-radius: 3px;
                            margin-right: 10px;
                            .close-icon {
                                margin-left: 9px;
                            }
                        }
                        .tag:nth-child(1) {
                            background-color: #FEDE7F;
                        }
                        .tag:nth-child(2) {
                            background-color: #BBB4FF;
                        }
                        .add-button {
                            display: flex;
                            margin-top: 15px;
                            width: 17%;
                            .add-tag {
                                color: #51A3F3;
                                font-family: "Helvetica Neue";
                                font-size: 14px;
                                line-height: 25px;
                                font-weight: normal;
                            }
                        }
                    }
                }
            }
            .next-container {
                box-sizing: border-box;
                height: 347px;
                width: 706px !important;
                border: 3px solid #24E2B8 !important;
                border-radius: 6px !important;
                padding: 0 !important;
                .section-icon {
                    padding: 15px 15px 14px 15px!important;
                    background-color: #24E2B8 !important;
                    margin-left: 18px !important;
                    .svg-plus {
                        width: 24px;
                        height: 24px;
                        fill: #FFFFFF;
                    }
                }
                .container-title {
                    font-size: 21px;
                    font-family: 'Proxima Nova';
                    line-height: 30px;
                    color: #4D545E;
                    text-align: center;
                }
                .icons-wrapper {
                    .row {
                        display: flex;
                        margin: 10px 0;
                        .svg-container {
                            width: 140px;
                            text-align: center;
                            padding-top: 15px;
                            .svg-name {
                                color: #4D545E;
                                font-family: "Helvetica Neue";
                                font-size: 16px;
                                line-height: 25px;
                                text-align: center;
                                margin-top: 5px;
                                margin-bottom: 15px;
                            }
                            .red {
                                color: #D2305B;
                            }
                            svg {
                                height: 60px;
                            }
                            .svg-greeting {
                                width: 64px;
                                stroke: #70828B;
                                stroke-width: 1.5px;
                                fill: #FFFFFF;
                            }
                            .svg-dial {
                                width: 60px;
                                fill: #FFFFFF;
                            }
                            .svg-simulcall {
                                width: 66.86px;
                                stroke: #70828B;
                                fill: #FFFFFF;
                            }
                            .svg-menu {
                                width: 60px;
                                stroke: #70828B;
                                fill: #FFFFFF;
                                circle {
                                    stroke-width: 1.5px;
                                }
                            }
                            .svg-schedule {
                                width: 60px;
                                fill: #70828B;
                            }
                            .svg-geo-routing {
                                width: 47.84px;
                                fill: #FFFFFF;
                                stroke: #70828B;
                                stroke-width: 1.5px;
                            }
                            .svg-tag {
                                width: 58.44px;
                                fill: #70828B;
                            }
                            .svg-voicemail {
                                width: 70px;
                                fill: #FFFFFF;
                                stroke: #70828B;
                                rect {
                                    stroke-width: 3px;
                                }
                                path {
                                    stroke-width: 1px;
                                    fill: #70828B;
                                }
                            }
                            .svg-hang-up {
                                width: 64px;
                            }
                        }
                    }
                }
            }

            .select-container {
                height: 60px;
                .select {
                    height: 40px;
                    width: 300px;
                }
                .field {
                    height: 40px;
                    width: 345px;
                    p.pimary-input-title {
                        color: #000000;
                        font-family: ""Helvetica Neue"";
                        font-size: 12px;
                        font-weight: 300;
                    }
                }
            }
            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;
                margin-top: 31px;
                .action {
                    height: 40px;
                    width: 118px;
                    border: 1px solid #24E2A5;
                    color: #24E2A5;
                    font-size: 14px; //15
                    font-weight: 500;
                    line-height: 18px;
                    text-align: center;
                    margin-right: 10px;
                }
                .condition {
                    height: 40px;
                    width: 140px;
                    border: 1px solid #24E2A5;
                    color: #24E2A5;
                    font-size: 14px; //15
                    font-weight: 500;
                    line-height: 18px;
                    text-align: center;
                }
            }

        }
    }
</style>